const mn = Object.prototype.toString;
function ie(t) {
  switch (mn.call(t)) {
    case '[object Error]':
    case '[object Exception]':
    case '[object DOMException]':
    case '[object WebAssembly.Exception]':
      return !0;
    default:
      return G(t, Error);
  }
}
function tt(t, e) {
  return mn.call(t) === `[object ${e}]`;
}
function gn(t) {
  return tt(t, 'ErrorEvent');
}
function ve(t) {
  return tt(t, 'DOMError');
}
function ar(t) {
  return tt(t, 'DOMException');
}
function C(t) {
  return tt(t, 'String');
}
function ae(t) {
  return (
    typeof t == 'object' &&
    t !== null &&
    '__sentry_template_string__' in t &&
    '__sentry_template_values__' in t
  );
}
function ce(t) {
  return (
    t === null || ae(t) || (typeof t != 'object' && typeof t != 'function')
  );
}
function X(t) {
  return tt(t, 'Object');
}
function Ot(t) {
  return typeof Event < 'u' && G(t, Event);
}
function cr(t) {
  return typeof Element < 'u' && G(t, Element);
}
function ur(t) {
  return tt(t, 'RegExp');
}
function Dt(t) {
  return !!(t && t.then && typeof t.then == 'function');
}
function fr(t) {
  return (
    X(t) &&
    'nativeEvent' in t &&
    'preventDefault' in t &&
    'stopPropagation' in t
  );
}
function G(t, e) {
  try {
    return t instanceof e;
  } catch {
    return !1;
  }
}
function yn(t) {
  return !!(typeof t == 'object' && t !== null && (t.__isVue || t._isVue));
}
function K(t, e = 0) {
  return typeof t != 'string' || e === 0 || t.length <= e
    ? t
    : `${t.slice(0, e)}...`;
}
function ke(t, e) {
  if (!Array.isArray(t)) return '';
  const n = [];
  for (let r = 0; r < t.length; r++) {
    const s = t[r];
    try {
      yn(s) ? n.push('[VueViewModel]') : n.push(String(s));
    } catch {
      n.push('[value cannot be serialized]');
    }
  }
  return n.join(e);
}
function dr(t, e, n = !1) {
  return C(t)
    ? ur(e)
      ? e.test(t)
      : C(e)
      ? n
        ? t === e
        : t.includes(e)
      : !1
    : !1;
}
function At(t, e = [], n = !1) {
  return e.some((r) => dr(t, r, n));
}
function lr(t, e, n = 250, r, s, o, i) {
  if (
    !o.exception ||
    !o.exception.values ||
    !i ||
    !G(i.originalException, Error)
  )
    return;
  const a =
    o.exception.values.length > 0
      ? o.exception.values[o.exception.values.length - 1]
      : void 0;
  a &&
    (o.exception.values = pr(
      jt(t, e, s, i.originalException, r, o.exception.values, a, 0),
      n,
    ));
}
function jt(t, e, n, r, s, o, i, a) {
  if (o.length >= n + 1) return o;
  let c = [...o];
  if (G(r[s], Error)) {
    Ne(i, a);
    const u = t(e, r[s]),
      f = c.length;
    we(u, s, f, a), (c = jt(t, e, n, r[s], s, [u, ...c], u, f));
  }
  return (
    Array.isArray(r.errors) &&
      r.errors.forEach((u, f) => {
        if (G(u, Error)) {
          Ne(i, a);
          const d = t(e, u),
            p = c.length;
          we(d, `errors[${f}]`, p, a), (c = jt(t, e, n, u, s, [d, ...c], d, p));
        }
      }),
    c
  );
}
function Ne(t, e) {
  (t.mechanism = t.mechanism || { type: 'generic', handled: !0 }),
    (t.mechanism = {
      ...t.mechanism,
      ...(t.type === 'AggregateError' && { is_exception_group: !0 }),
      exception_id: e,
    });
}
function we(t, e, n, r) {
  (t.mechanism = t.mechanism || { type: 'generic', handled: !0 }),
    (t.mechanism = {
      ...t.mechanism,
      type: 'chained',
      source: e,
      exception_id: n,
      parent_id: r,
    });
}
function pr(t, e) {
  return t.map((n) => (n.value && (n.value = K(n.value, e)), n));
}
function Sn(t) {
  if (t !== void 0)
    return t >= 400 && t < 500 ? 'warning' : t >= 500 ? 'error' : void 0;
}
const x = '8.38.0',
  g = globalThis;
function $t(t, e, n) {
  const r = g,
    s = (r.__SENTRY__ = r.__SENTRY__ || {}),
    o = (s[x] = s[x] || {});
  return o[t] || (o[t] = e());
}
const ue = g,
  hr = 80;
function En(t, e = {}) {
  if (!t) return '<unknown>';
  try {
    let n = t;
    const r = 5,
      s = [];
    let o = 0,
      i = 0;
    const a = ' > ',
      c = a.length;
    let u;
    const f = Array.isArray(e) ? e : e.keyAttrs,
      d = (!Array.isArray(e) && e.maxStringLength) || hr;
    for (
      ;
      n &&
      o++ < r &&
      ((u = _r(n, f)),
      !(u === 'html' || (o > 1 && i + s.length * c + u.length >= d)));

    )
      s.push(u), (i += u.length), (n = n.parentNode);
    return s.reverse().join(a);
  } catch {
    return '<unknown>';
  }
}
function _r(t, e) {
  const n = t,
    r = [];
  if (!n || !n.tagName) return '';
  if (ue.HTMLElement && n instanceof HTMLElement && n.dataset) {
    if (n.dataset.sentryComponent) return n.dataset.sentryComponent;
    if (n.dataset.sentryElement) return n.dataset.sentryElement;
  }
  r.push(n.tagName.toLowerCase());
  const s =
    e && e.length
      ? e.filter((i) => n.getAttribute(i)).map((i) => [i, n.getAttribute(i)])
      : null;
  if (s && s.length)
    s.forEach((i) => {
      r.push(`[${i[0]}="${i[1]}"]`);
    });
  else {
    n.id && r.push(`#${n.id}`);
    const i = n.className;
    if (i && C(i)) {
      const a = i.split(/\s+/);
      for (const c of a) r.push(`.${c}`);
    }
  }
  const o = ['aria-label', 'type', 'name', 'title', 'alt'];
  for (const i of o) {
    const a = n.getAttribute(i);
    a && r.push(`[${i}="${a}"]`);
  }
  return r.join('');
}
function mr() {
  try {
    return ue.document.location.href;
  } catch {
    return '';
  }
}
function gr(t) {
  if (!ue.HTMLElement) return null;
  let e = t;
  const n = 5;
  for (let r = 0; r < n; r++) {
    if (!e) return null;
    if (e instanceof HTMLElement) {
      if (e.dataset.sentryComponent) return e.dataset.sentryComponent;
      if (e.dataset.sentryElement) return e.dataset.sentryElement;
    }
    e = e.parentNode;
  }
  return null;
}
const et = typeof __SENTRY_DEBUG__ > 'u' || __SENTRY_DEBUG__,
  yr = 'Sentry Logger ',
  Ht = ['debug', 'info', 'warn', 'error', 'log', 'assert', 'trace'],
  kt = {};
function B(t) {
  if (!('console' in g)) return t();
  const e = g.console,
    n = {},
    r = Object.keys(kt);
  r.forEach((s) => {
    const o = kt[s];
    (n[s] = e[s]), (e[s] = o);
  });
  try {
    return t();
  } finally {
    r.forEach((s) => {
      e[s] = n[s];
    });
  }
}
function Sr() {
  let t = !1;
  const e = {
    enable: () => {
      t = !0;
    },
    disable: () => {
      t = !1;
    },
    isEnabled: () => t,
  };
  return (
    et
      ? Ht.forEach((n) => {
          e[n] = (...r) => {
            t &&
              B(() => {
                g.console[n](`${yr}[${n}]:`, ...r);
              });
          };
        })
      : Ht.forEach((n) => {
          e[n] = () => {};
        }),
    e
  );
}
const l = $t('logger', Sr),
  Er = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function br(t) {
  return t === 'http' || t === 'https';
}
function ft(t, e = !1) {
  const {
    host: n,
    path: r,
    pass: s,
    port: o,
    projectId: i,
    protocol: a,
    publicKey: c,
  } = t;
  return `${a}://${c}${e && s ? `:${s}` : ''}@${n}${o ? `:${o}` : ''}/${
    r && `${r}/`
  }${i}`;
}
function Tr(t) {
  const e = Er.exec(t);
  if (!e) {
    B(() => {
      console.error(`Invalid Sentry Dsn: ${t}`);
    });
    return;
  }
  const [n, r, s = '', o = '', i = '', a = ''] = e.slice(1);
  let c = '',
    u = a;
  const f = u.split('/');
  if ((f.length > 1 && ((c = f.slice(0, -1).join('/')), (u = f.pop())), u)) {
    const d = u.match(/^\d+/);
    d && (u = d[0]);
  }
  return bn({
    host: o,
    pass: s,
    path: c,
    projectId: u,
    port: i,
    protocol: n,
    publicKey: r,
  });
}
function bn(t) {
  return {
    protocol: t.protocol,
    publicKey: t.publicKey || '',
    pass: t.pass || '',
    host: t.host,
    port: t.port || '',
    path: t.path || '',
    projectId: t.projectId,
  };
}
function Ir(t) {
  if (!et) return !0;
  const { port: e, projectId: n, protocol: r } = t;
  return ['protocol', 'publicKey', 'host', 'projectId'].find((i) =>
    t[i] ? !1 : (l.error(`Invalid Sentry Dsn: ${i} missing`), !0),
  )
    ? !1
    : n.match(/^\d+$/)
    ? br(r)
      ? e && isNaN(parseInt(e, 10))
        ? (l.error(`Invalid Sentry Dsn: Invalid port ${e}`), !1)
        : !0
      : (l.error(`Invalid Sentry Dsn: Invalid protocol ${r}`), !1)
    : (l.error(`Invalid Sentry Dsn: Invalid projectId ${n}`), !1);
}
function vr(t) {
  const e = typeof t == 'string' ? Tr(t) : bn(t);
  if (!(!e || !Ir(e))) return e;
}
class A extends Error {
  /** Display name of this error instance. */
  constructor(e, n = 'warn') {
    super(e),
      (this.message = e),
      (this.name = new.target.prototype.constructor.name),
      Object.setPrototypeOf(this, new.target.prototype),
      (this.logLevel = n);
  }
}
function v(t, e, n) {
  if (!(e in t)) return;
  const r = t[e],
    s = n(r);
  typeof s == 'function' && Tn(s, r), (t[e] = s);
}
function w(t, e, n) {
  try {
    Object.defineProperty(t, e, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: n,
      writable: !0,
      configurable: !0,
    });
  } catch {
    et && l.log(`Failed to add non-enumerable property "${e}" to object`, t);
  }
}
function Tn(t, e) {
  try {
    const n = e.prototype || {};
    (t.prototype = e.prototype = n), w(t, '__sentry_original__', e);
  } catch {}
}
function fe(t) {
  return t.__sentry_original__;
}
function kr(t) {
  return Object.keys(t)
    .map((e) => `${encodeURIComponent(e)}=${encodeURIComponent(t[e])}`)
    .join('&');
}
function In(t) {
  if (ie(t))
    return {
      message: t.message,
      name: t.name,
      stack: t.stack,
      ...Oe(t),
    };
  if (Ot(t)) {
    const e = {
      type: t.type,
      target: Re(t.target),
      currentTarget: Re(t.currentTarget),
      ...Oe(t),
    };
    return (
      typeof CustomEvent < 'u' && G(t, CustomEvent) && (e.detail = t.detail), e
    );
  } else return t;
}
function Re(t) {
  try {
    return cr(t) ? En(t) : Object.prototype.toString.call(t);
  } catch {
    return '<unknown>';
  }
}
function Oe(t) {
  if (typeof t == 'object' && t !== null) {
    const e = {};
    for (const n in t)
      Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    return e;
  } else return {};
}
function Nr(t, e = 40) {
  const n = Object.keys(In(t));
  n.sort();
  const r = n[0];
  if (!r) return '[object has no keys]';
  if (r.length >= e) return K(r, e);
  for (let s = n.length; s > 0; s--) {
    const o = n.slice(0, s).join(', ');
    if (!(o.length > e)) return s === n.length ? o : K(o, e);
  }
  return '';
}
function I(t) {
  return Bt(t, /* @__PURE__ */ new Map());
}
function Bt(t, e) {
  if (wr(t)) {
    const n = e.get(t);
    if (n !== void 0) return n;
    const r = {};
    e.set(t, r);
    for (const s of Object.getOwnPropertyNames(t))
      typeof t[s] < 'u' && (r[s] = Bt(t[s], e));
    return r;
  }
  if (Array.isArray(t)) {
    const n = e.get(t);
    if (n !== void 0) return n;
    const r = [];
    return (
      e.set(t, r),
      t.forEach((s) => {
        r.push(Bt(s, e));
      }),
      r
    );
  }
  return t;
}
function wr(t) {
  if (!X(t)) return !1;
  try {
    const e = Object.getPrototypeOf(t).constructor.name;
    return !e || e === 'Object';
  } catch {
    return !0;
  }
}
const vn = 50,
  W = '?',
  De = /\(error: (.*)\)/,
  Ae = /captureMessage|captureException/;
function kn(...t) {
  const e = t.sort((n, r) => n[0] - r[0]).map((n) => n[1]);
  return (n, r = 0, s = 0) => {
    const o = [],
      i = n.split(`
`);
    for (let a = r; a < i.length; a++) {
      const c = i[a];
      if (c.length > 1024) continue;
      const u = De.test(c) ? c.replace(De, '$1') : c;
      if (!u.match(/\S*Error: /)) {
        for (const f of e) {
          const d = f(u);
          if (d) {
            o.push(d);
            break;
          }
        }
        if (o.length >= vn + s) break;
      }
    }
    return Or(o.slice(s));
  };
}
function Rr(t) {
  return Array.isArray(t) ? kn(...t) : t;
}
function Or(t) {
  if (!t.length) return [];
  const e = Array.from(t);
  return (
    /sentryWrapped/.test(gt(e).function || '') && e.pop(),
    e.reverse(),
    Ae.test(gt(e).function || '') &&
      (e.pop(), Ae.test(gt(e).function || '') && e.pop()),
    e.slice(0, vn).map((n) => ({
      ...n,
      filename: n.filename || gt(e).filename,
      function: n.function || W,
    }))
  );
}
function gt(t) {
  return t[t.length - 1] || {};
}
const Mt = '<anonymous>';
function U(t) {
  try {
    return !t || typeof t != 'function' ? Mt : t.name || Mt;
  } catch {
    return Mt;
  }
}
function $e(t) {
  const e = t.exception;
  if (e) {
    const n = [];
    try {
      return (
        e.values.forEach((r) => {
          r.stacktrace.frames && n.push(...r.stacktrace.frames);
        }),
        n
      );
    } catch {
      return;
    }
  }
}
const It = {},
  Ce = {};
function q(t, e) {
  (It[t] = It[t] || []), It[t].push(e);
}
function V(t, e) {
  if (!Ce[t]) {
    Ce[t] = !0;
    try {
      e();
    } catch (n) {
      et && l.error(`Error while instrumenting ${t}`, n);
    }
  }
}
function D(t, e) {
  const n = t && It[t];
  if (n)
    for (const r of n)
      try {
        r(e);
      } catch (s) {
        et &&
          l.error(
            `Error while triggering instrumentation handler.
Type: ${t}
Name: ${U(r)}
Error:`,
            s,
          );
      }
}
function Dr(t) {
  const e = 'console';
  q(e, t), V(e, Ar);
}
function Ar() {
  'console' in g &&
    Ht.forEach(function (t) {
      t in g.console &&
        v(g.console, t, function (e) {
          return (
            (kt[t] = e),
            function (...n) {
              D('console', { args: n, level: t });
              const s = kt[t];
              s && s.apply(g.console, n);
            }
          );
        });
    });
}
const Gt = g;
function Nn() {
  if (!('fetch' in Gt)) return !1;
  try {
    return (
      new Headers(), new Request('http://www.example.com'), new Response(), !0
    );
  } catch {
    return !1;
  }
}
function Wt(t) {
  return (
    t && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(t.toString())
  );
}
function $r() {
  if (typeof EdgeRuntime == 'string') return !0;
  if (!Nn()) return !1;
  if (Wt(Gt.fetch)) return !0;
  let t = !1;
  const e = Gt.document;
  if (e && typeof e.createElement == 'function')
    try {
      const n = e.createElement('iframe');
      (n.hidden = !0),
        e.head.appendChild(n),
        n.contentWindow &&
          n.contentWindow.fetch &&
          (t = Wt(n.contentWindow.fetch)),
        e.head.removeChild(n);
    } catch (n) {
      et &&
        l.warn(
          'Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ',
          n,
        );
    }
  return t;
}
const wn = 1e3;
function dt() {
  return Date.now() / wn;
}
function Cr() {
  const { performance: t } = g;
  if (!t || !t.now) return dt;
  const e = Date.now() - t.now(),
    n = t.timeOrigin == null ? e : t.timeOrigin;
  return () => (n + t.now()) / wn;
}
const N = Cr();
(() => {
  const { performance: t } = g;
  if (!t || !t.now) return;
  const e = 3600 * 1e3,
    n = t.now(),
    r = Date.now(),
    s = t.timeOrigin ? Math.abs(t.timeOrigin + n - r) : e,
    o = s < e,
    i = t.timing && t.timing.navigationStart,
    c = typeof i == 'number' ? Math.abs(i + n - r) : e,
    u = c < e;
  return o || u ? (s <= c ? t.timeOrigin : i) : r;
})();
function xr(t, e) {
  const n = 'fetch';
  q(n, t), V(n, () => Pr(void 0, e));
}
function Pr(t, e = !1) {
  (e && !$r()) ||
    v(g, 'fetch', function (n) {
      return function (...r) {
        const { method: s, url: o } = Mr(r),
          i = {
            args: r,
            fetchData: {
              method: s,
              url: o,
            },
            startTimestamp: N() * 1e3,
          };
        D('fetch', {
          ...i,
        });
        const a = new Error().stack;
        return n.apply(g, r).then(
          async (c) => (
            D('fetch', {
              ...i,
              endTimestamp: N() * 1e3,
              response: c,
            }),
            c
          ),
          (c) => {
            throw (
              (D('fetch', {
                ...i,
                endTimestamp: N() * 1e3,
                error: c,
              }),
              ie(c) &&
                c.stack === void 0 &&
                ((c.stack = a), w(c, 'framesToPop', 1)),
              c)
            );
          },
        );
      };
    });
}
function Yt(t, e) {
  return !!t && typeof t == 'object' && !!t[e];
}
function xe(t) {
  return typeof t == 'string'
    ? t
    : t
    ? Yt(t, 'url')
      ? t.url
      : t.toString
      ? t.toString()
      : ''
    : '';
}
function Mr(t) {
  if (t.length === 0) return { method: 'GET', url: '' };
  if (t.length === 2) {
    const [n, r] = t;
    return {
      url: xe(n),
      method: Yt(r, 'method') ? String(r.method).toUpperCase() : 'GET',
    };
  }
  const e = t[0];
  return {
    url: xe(e),
    method: Yt(e, 'method') ? String(e.method).toUpperCase() : 'GET',
  };
}
let yt = null;
function Lr(t) {
  const e = 'error';
  q(e, t), V(e, Fr);
}
function Fr() {
  (yt = g.onerror),
    (g.onerror = function (t, e, n, r, s) {
      return (
        D('error', {
          column: r,
          error: s,
          line: n,
          msg: t,
          url: e,
        }),
        yt && !yt.__SENTRY_LOADER__ ? yt.apply(this, arguments) : !1
      );
    }),
    (g.onerror.__SENTRY_INSTRUMENTED__ = !0);
}
let St = null;
function Ur(t) {
  const e = 'unhandledrejection';
  q(e, t), V(e, jr);
}
function jr() {
  (St = g.onunhandledrejection),
    (g.onunhandledrejection = function (t) {
      return (
        D('unhandledrejection', t),
        St && !St.__SENTRY_LOADER__ ? St.apply(this, arguments) : !0
      );
    }),
    (g.onunhandledrejection.__SENTRY_INSTRUMENTED__ = !0);
}
function Hr() {
  return 'npm';
}
function Br() {
  const t = typeof WeakSet == 'function',
    e = t ? /* @__PURE__ */ new WeakSet() : [];
  function n(s) {
    if (t) return e.has(s) ? !0 : (e.add(s), !1);
    for (let o = 0; o < e.length; o++) if (e[o] === s) return !0;
    return e.push(s), !1;
  }
  function r(s) {
    if (t) e.delete(s);
    else
      for (let o = 0; o < e.length; o++)
        if (e[o] === s) {
          e.splice(o, 1);
          break;
        }
  }
  return [n, r];
}
function b() {
  const t = g,
    e = t.crypto || t.msCrypto;
  let n = () => Math.random() * 16;
  try {
    if (e && e.randomUUID) return e.randomUUID().replace(/-/g, '');
    e &&
      e.getRandomValues &&
      (n = () => {
        const r = new Uint8Array(1);
        return e.getRandomValues(r), r[0];
      });
  } catch {}
  return ('10000000100040008000' + 1e11).replace(/[018]/g, (r) =>
    // eslint-disable-next-line no-bitwise
    (r ^ ((n() & 15) >> (r / 4))).toString(16),
  );
}
function Rn(t) {
  return t.exception && t.exception.values ? t.exception.values[0] : void 0;
}
function M(t) {
  const { message: e, event_id: n } = t;
  if (e) return e;
  const r = Rn(t);
  return r
    ? r.type && r.value
      ? `${r.type}: ${r.value}`
      : r.type || r.value || n || '<unknown>'
    : n || '<unknown>';
}
function qt(t, e, n) {
  const r = (t.exception = t.exception || {}),
    s = (r.values = r.values || []),
    o = (s[0] = s[0] || {});
  o.value || (o.value = e || ''), o.type || (o.type = 'Error');
}
function ct(t, e) {
  const n = Rn(t);
  if (!n) return;
  const r = { type: 'generic', handled: !0 },
    s = n.mechanism;
  if (((n.mechanism = { ...r, ...s, ...e }), e && 'data' in e)) {
    const o = { ...(s && s.data), ...e.data };
    n.mechanism.data = o;
  }
}
function Pe(t) {
  if (t && t.__sentry_captured__) return !0;
  try {
    w(t, '__sentry_captured__', !0);
  } catch {}
  return !1;
}
function de(t) {
  return Array.isArray(t) ? t : [t];
}
function L(t, e = 100, n = 1 / 0) {
  try {
    return Vt('', t, e, n);
  } catch (r) {
    return { ERROR: `**non-serializable** (${r})` };
  }
}
function On(t, e = 3, n = 100 * 1024) {
  const r = L(t, e);
  return qr(r) > n ? On(t, e - 1, n) : r;
}
function Vt(t, e, n = 1 / 0, r = 1 / 0, s = Br()) {
  const [o, i] = s;
  if (
    e == null || // this matches null and undefined -> eqeq not eqeqeq
    ['boolean', 'string'].includes(typeof e) ||
    (typeof e == 'number' && Number.isFinite(e))
  )
    return e;
  const a = Gr(t, e);
  if (!a.startsWith('[object ')) return a;
  if (e.__sentry_skip_normalization__) return e;
  const c =
    typeof e.__sentry_override_normalization_depth__ == 'number'
      ? e.__sentry_override_normalization_depth__
      : n;
  if (c === 0) return a.replace('object ', '');
  if (o(e)) return '[Circular ~]';
  const u = e;
  if (u && typeof u.toJSON == 'function')
    try {
      const m = u.toJSON();
      return Vt('', m, c - 1, r, s);
    } catch {}
  const f = Array.isArray(e) ? [] : {};
  let d = 0;
  const p = In(e);
  for (const m in p) {
    if (!Object.prototype.hasOwnProperty.call(p, m)) continue;
    if (d >= r) {
      f[m] = '[MaxProperties ~]';
      break;
    }
    const _ = p[m];
    (f[m] = Vt(m, _, c - 1, r, s)), d++;
  }
  return i(e), f;
}
function Gr(t, e) {
  try {
    if (t === 'domain' && e && typeof e == 'object' && e._events)
      return '[Domain]';
    if (t === 'domainEmitter') return '[DomainEmitter]';
    if (typeof global < 'u' && e === global) return '[Global]';
    if (typeof window < 'u' && e === window) return '[Window]';
    if (typeof document < 'u' && e === document) return '[Document]';
    if (yn(e)) return '[VueViewModel]';
    if (fr(e)) return '[SyntheticEvent]';
    if (typeof e == 'number' && !Number.isFinite(e)) return `[${e}]`;
    if (typeof e == 'function') return `[Function: ${U(e)}]`;
    if (typeof e == 'symbol') return `[${String(e)}]`;
    if (typeof e == 'bigint') return `[BigInt: ${String(e)}]`;
    const n = Wr(e);
    return /^HTML(\w*)Element$/.test(n)
      ? `[HTMLElement: ${n}]`
      : `[object ${n}]`;
  } catch (n) {
    return `**non-serializable** (${n})`;
  }
}
function Wr(t) {
  const e = Object.getPrototypeOf(t);
  return e ? e.constructor.name : 'null prototype';
}
function Yr(t) {
  return ~-encodeURI(t).split(/%..|./).length;
}
function qr(t) {
  return Yr(JSON.stringify(t));
}
var $;
(function (t) {
  t[(t.PENDING = 0)] = 'PENDING';
  const n = 1;
  t[(t.RESOLVED = n)] = 'RESOLVED';
  const r = 2;
  t[(t.REJECTED = r)] = 'REJECTED';
})($ || ($ = {}));
function Y(t) {
  return new k((e) => {
    e(t);
  });
}
function Nt(t) {
  return new k((e, n) => {
    n(t);
  });
}
class k {
  constructor(e) {
    k.prototype.__init.call(this),
      k.prototype.__init2.call(this),
      k.prototype.__init3.call(this),
      k.prototype.__init4.call(this),
      (this._state = $.PENDING),
      (this._handlers = []);
    try {
      e(this._resolve, this._reject);
    } catch (n) {
      this._reject(n);
    }
  }
  /** JSDoc */
  then(e, n) {
    return new k((r, s) => {
      this._handlers.push([
        !1,
        (o) => {
          if (!e) r(o);
          else
            try {
              r(e(o));
            } catch (i) {
              s(i);
            }
        },
        (o) => {
          if (!n) s(o);
          else
            try {
              r(n(o));
            } catch (i) {
              s(i);
            }
        },
      ]),
        this._executeHandlers();
    });
  }
  /** JSDoc */
  catch(e) {
    return this.then((n) => n, e);
  }
  /** JSDoc */
  finally(e) {
    return new k((n, r) => {
      let s, o;
      return this.then(
        (i) => {
          (o = !1), (s = i), e && e();
        },
        (i) => {
          (o = !0), (s = i), e && e();
        },
      ).then(() => {
        if (o) {
          r(s);
          return;
        }
        n(s);
      });
    });
  }
  /** JSDoc */
  __init() {
    this._resolve = (e) => {
      this._setResult($.RESOLVED, e);
    };
  }
  /** JSDoc */
  __init2() {
    this._reject = (e) => {
      this._setResult($.REJECTED, e);
    };
  }
  /** JSDoc */
  __init3() {
    this._setResult = (e, n) => {
      if (this._state === $.PENDING) {
        if (Dt(n)) {
          n.then(this._resolve, this._reject);
          return;
        }
        (this._state = e), (this._value = n), this._executeHandlers();
      }
    };
  }
  /** JSDoc */
  __init4() {
    this._executeHandlers = () => {
      if (this._state === $.PENDING) return;
      const e = this._handlers.slice();
      (this._handlers = []),
        e.forEach((n) => {
          n[0] ||
            (this._state === $.RESOLVED && n[1](this._value),
            this._state === $.REJECTED && n[2](this._value),
            (n[0] = !0));
        });
    };
  }
}
function Vr(t) {
  const e = [];
  function n() {
    return t === void 0 || e.length < t;
  }
  function r(i) {
    return e.splice(e.indexOf(i), 1)[0] || Promise.resolve(void 0);
  }
  function s(i) {
    if (!n())
      return Nt(new A('Not adding Promise because buffer limit was reached.'));
    const a = i();
    return (
      e.indexOf(a) === -1 && e.push(a),
      a.then(() => r(a)).then(null, () => r(a).then(null, () => {})),
      a
    );
  }
  function o(i) {
    return new k((a, c) => {
      let u = e.length;
      if (!u) return a(!0);
      const f = setTimeout(() => {
        i && i > 0 && a(!1);
      }, i);
      e.forEach((d) => {
        Y(d).then(() => {
          --u || (clearTimeout(f), a(!0));
        }, c);
      });
    });
  }
  return {
    $: e,
    add: s,
    drain: o,
  };
}
function Lt(t) {
  if (!t) return {};
  const e = t.match(
    /^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/,
  );
  if (!e) return {};
  const n = e[6] || '',
    r = e[8] || '';
  return {
    host: e[4],
    path: e[5],
    protocol: e[2],
    search: n,
    hash: r,
    relative: e[5] + n + r,
    // everything minus origin
  };
}
const Kr = ['fatal', 'error', 'warning', 'log', 'info', 'debug'];
function zr(t) {
  return t === 'warn' ? 'warning' : Kr.includes(t) ? t : 'log';
}
const Xr = 'sentry-',
  Jr = /^sentry-/;
function Zr(t) {
  const e = Qr(t);
  if (!e) return;
  const n = Object.entries(e).reduce((r, [s, o]) => {
    if (s.match(Jr)) {
      const i = s.slice(Xr.length);
      r[i] = o;
    }
    return r;
  }, {});
  if (Object.keys(n).length > 0) return n;
}
function Qr(t) {
  if (!(!t || (!C(t) && !Array.isArray(t))))
    return Array.isArray(t)
      ? t.reduce((e, n) => {
          const r = Me(n);
          return (
            Object.entries(r).forEach(([s, o]) => {
              e[s] = o;
            }),
            e
          );
        }, {})
      : Me(t);
}
function Me(t) {
  return t
    .split(',')
    .map((e) => e.split('=').map((n) => decodeURIComponent(n.trim())))
    .reduce((e, [n, r]) => (n && r && (e[n] = r), e), {});
}
function nt(t, e = []) {
  return [t, e];
}
function ts(t, e) {
  const [n, r] = t;
  return [n, [...r, e]];
}
function Le(t, e) {
  const n = t[1];
  for (const r of n) {
    const s = r[0].type;
    if (e(r, s)) return !0;
  }
  return !1;
}
function Kt(t) {
  return g.__SENTRY__ && g.__SENTRY__.encodePolyfill
    ? g.__SENTRY__.encodePolyfill(t)
    : new TextEncoder().encode(t);
}
function es(t) {
  const [e, n] = t;
  let r = JSON.stringify(e);
  function s(o) {
    typeof r == 'string'
      ? (r = typeof o == 'string' ? r + o : [Kt(r), o])
      : r.push(typeof o == 'string' ? Kt(o) : o);
  }
  for (const o of n) {
    const [i, a] = o;
    if (
      (s(`
${JSON.stringify(i)}
`),
      typeof a == 'string' || a instanceof Uint8Array)
    )
      s(a);
    else {
      let c;
      try {
        c = JSON.stringify(a);
      } catch {
        c = JSON.stringify(L(a));
      }
      s(c);
    }
  }
  return typeof r == 'string' ? r : ns(r);
}
function ns(t) {
  const e = t.reduce((s, o) => s + o.length, 0),
    n = new Uint8Array(e);
  let r = 0;
  for (const s of t) n.set(s, r), (r += s.length);
  return n;
}
function rs(t) {
  return [
    {
      type: 'span',
    },
    t,
  ];
}
function ss(t) {
  const e = typeof t.data == 'string' ? Kt(t.data) : t.data;
  return [
    I({
      type: 'attachment',
      length: e.length,
      filename: t.filename,
      content_type: t.contentType,
      attachment_type: t.attachmentType,
    }),
    e,
  ];
}
const os = {
  session: 'session',
  sessions: 'session',
  attachment: 'attachment',
  transaction: 'transaction',
  event: 'error',
  client_report: 'internal',
  user_report: 'default',
  profile: 'profile',
  profile_chunk: 'profile',
  replay_event: 'replay',
  replay_recording: 'replay',
  check_in: 'monitor',
  feedback: 'feedback',
  span: 'span',
  statsd: 'metric_bucket',
};
function Fe(t) {
  return os[t];
}
function Dn(t) {
  if (!t || !t.sdk) return;
  const { name: e, version: n } = t.sdk;
  return { name: e, version: n };
}
function is(t, e, n, r) {
  const s =
    t.sdkProcessingMetadata && t.sdkProcessingMetadata.dynamicSamplingContext;
  return {
    event_id: t.event_id,
    sent_at: /* @__PURE__ */ new Date().toISOString(),
    ...(e && { sdk: e }),
    ...(!!n && r && { dsn: ft(r) }),
    ...(s && {
      trace: I({ ...s }),
    }),
  };
}
function as(t, e, n) {
  const r = [
    { type: 'client_report' },
    {
      timestamp: dt(),
      discarded_events: t,
    },
  ];
  return nt(e ? { dsn: e } : {}, [r]);
}
const cs = 60 * 1e3;
function us(t, e = Date.now()) {
  const n = parseInt(`${t}`, 10);
  if (!isNaN(n)) return n * 1e3;
  const r = Date.parse(`${t}`);
  return isNaN(r) ? cs : r - e;
}
function fs(t, e) {
  return t[e] || t.all || 0;
}
function ds(t, e, n = Date.now()) {
  return fs(t, e) > n;
}
function ls(t, { statusCode: e, headers: n }, r = Date.now()) {
  const s = {
      ...t,
    },
    o = n && n['x-sentry-rate-limits'],
    i = n && n['retry-after'];
  if (o)
    for (const a of o.trim().split(',')) {
      const [c, u, , , f] = a.split(':', 5),
        d = parseInt(c, 10),
        p = (isNaN(d) ? 60 : d) * 1e3;
      if (!u) s.all = r + p;
      else
        for (const m of u.split(';'))
          m === 'metric_bucket'
            ? (!f || f.split(';').includes('custom')) && (s[m] = r + p)
            : (s[m] = r + p);
    }
  else i ? (s.all = r + us(i, r)) : e === 429 && (s.all = r + 60 * 1e3);
  return s;
}
function Ue() {
  return {
    traceId: b(),
    spanId: b().substring(16),
  };
}
const je = /* @__PURE__ */ new WeakMap();
function ps(t) {
  const e = g._sentryDebugIds;
  if (!e) return {};
  let n;
  const r = je.get(t);
  return (
    r ? (n = r) : ((n = /* @__PURE__ */ new Map()), je.set(t, n)),
    Object.keys(e).reduce((s, o) => {
      let i;
      const a = n.get(o);
      a ? (i = a) : ((i = t(o)), n.set(o, i));
      for (let c = i.length - 1; c >= 0; c--) {
        const u = i[c],
          f = u && u.filename;
        if (u && f) {
          s[f] = e[o];
          break;
        }
      }
      return s;
    }, {})
  );
}
const Et = g;
function hs() {
  const t = Et.chrome,
    e = t && t.app && t.app.runtime,
    n = 'history' in Et && !!Et.history.pushState && !!Et.history.replaceState;
  return !e && n;
}
const h = typeof __SENTRY_DEBUG__ > 'u' || __SENTRY_DEBUG__;
function rt() {
  return le(g), g;
}
function le(t) {
  const e = (t.__SENTRY__ = t.__SENTRY__ || {});
  return (e.version = e.version || x), (e[x] = e[x] || {});
}
function _s(t) {
  const e = N(),
    n = {
      sid: b(),
      init: !0,
      timestamp: e,
      started: e,
      duration: 0,
      status: 'ok',
      errors: 0,
      ignoreDuration: !1,
      toJSON: () => gs(n),
    };
  return J(n, t), n;
}
function J(t, e = {}) {
  if (
    (e.user &&
      (!t.ipAddress && e.user.ip_address && (t.ipAddress = e.user.ip_address),
      !t.did &&
        !e.did &&
        (t.did = e.user.id || e.user.email || e.user.username)),
    (t.timestamp = e.timestamp || N()),
    e.abnormal_mechanism && (t.abnormal_mechanism = e.abnormal_mechanism),
    e.ignoreDuration && (t.ignoreDuration = e.ignoreDuration),
    e.sid && (t.sid = e.sid.length === 32 ? e.sid : b()),
    e.init !== void 0 && (t.init = e.init),
    !t.did && e.did && (t.did = `${e.did}`),
    typeof e.started == 'number' && (t.started = e.started),
    t.ignoreDuration)
  )
    t.duration = void 0;
  else if (typeof e.duration == 'number') t.duration = e.duration;
  else {
    const n = t.timestamp - t.started;
    t.duration = n >= 0 ? n : 0;
  }
  e.release && (t.release = e.release),
    e.environment && (t.environment = e.environment),
    !t.ipAddress && e.ipAddress && (t.ipAddress = e.ipAddress),
    !t.userAgent && e.userAgent && (t.userAgent = e.userAgent),
    typeof e.errors == 'number' && (t.errors = e.errors),
    e.status && (t.status = e.status);
}
function ms(t, e) {
  let n = {};
  t.status === 'ok' && (n = { status: 'exited' }), J(t, n);
}
function gs(t) {
  return I({
    sid: `${t.sid}`,
    init: t.init,
    // Make sure that sec is converted to ms for date constructor
    started: new Date(t.started * 1e3).toISOString(),
    timestamp: new Date(t.timestamp * 1e3).toISOString(),
    status: t.status,
    errors: t.errors,
    did:
      typeof t.did == 'number' || typeof t.did == 'string'
        ? `${t.did}`
        : void 0,
    duration: t.duration,
    abnormal_mechanism: t.abnormal_mechanism,
    attrs: {
      release: t.release,
      environment: t.environment,
      ip_address: t.ipAddress,
      user_agent: t.userAgent,
    },
  });
}
const zt = '_sentrySpan';
function Xt(t, e) {
  e ? w(t, zt, e) : delete t[zt];
}
function wt(t) {
  return t[zt];
}
const ys = 100;
class pe {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called during event processing. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */
  /** Session */
  /** Request Mode Session Status */
  /** The client on this scope */
  /** Contains the last event id of a captured event.  */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    (this._notifyingListeners = !1),
      (this._scopeListeners = []),
      (this._eventProcessors = []),
      (this._breadcrumbs = []),
      (this._attachments = []),
      (this._user = {}),
      (this._tags = {}),
      (this._extra = {}),
      (this._contexts = {}),
      (this._sdkProcessingMetadata = {}),
      (this._propagationContext = Ue());
  }
  /**
   * @inheritDoc
   */
  clone() {
    const e = new pe();
    return (
      (e._breadcrumbs = [...this._breadcrumbs]),
      (e._tags = { ...this._tags }),
      (e._extra = { ...this._extra }),
      (e._contexts = { ...this._contexts }),
      (e._user = this._user),
      (e._level = this._level),
      (e._session = this._session),
      (e._transactionName = this._transactionName),
      (e._fingerprint = this._fingerprint),
      (e._eventProcessors = [...this._eventProcessors]),
      (e._requestSession = this._requestSession),
      (e._attachments = [...this._attachments]),
      (e._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }),
      (e._propagationContext = { ...this._propagationContext }),
      (e._client = this._client),
      (e._lastEventId = this._lastEventId),
      Xt(e, wt(this)),
      e
    );
  }
  /**
   * @inheritDoc
   */
  setClient(e) {
    this._client = e;
  }
  /**
   * @inheritDoc
   */
  setLastEventId(e) {
    this._lastEventId = e;
  }
  /**
   * @inheritDoc
   */
  getClient() {
    return this._client;
  }
  /**
   * @inheritDoc
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addScopeListener(e) {
    this._scopeListeners.push(e);
  }
  /**
   * @inheritDoc
   */
  addEventProcessor(e) {
    return this._eventProcessors.push(e), this;
  }
  /**
   * @inheritDoc
   */
  setUser(e) {
    return (
      (this._user = e || {
        email: void 0,
        id: void 0,
        ip_address: void 0,
        username: void 0,
      }),
      this._session && J(this._session, { user: e }),
      this._notifyScopeListeners(),
      this
    );
  }
  /**
   * @inheritDoc
   */
  getUser() {
    return this._user;
  }
  /**
   * @inheritDoc
   */
  getRequestSession() {
    return this._requestSession;
  }
  /**
   * @inheritDoc
   */
  setRequestSession(e) {
    return (this._requestSession = e), this;
  }
  /**
   * @inheritDoc
   */
  setTags(e) {
    return (
      (this._tags = {
        ...this._tags,
        ...e,
      }),
      this._notifyScopeListeners(),
      this
    );
  }
  /**
   * @inheritDoc
   */
  setTag(e, n) {
    return (
      (this._tags = { ...this._tags, [e]: n }),
      this._notifyScopeListeners(),
      this
    );
  }
  /**
   * @inheritDoc
   */
  setExtras(e) {
    return (
      (this._extra = {
        ...this._extra,
        ...e,
      }),
      this._notifyScopeListeners(),
      this
    );
  }
  /**
   * @inheritDoc
   */
  setExtra(e, n) {
    return (
      (this._extra = { ...this._extra, [e]: n }),
      this._notifyScopeListeners(),
      this
    );
  }
  /**
   * @inheritDoc
   */
  setFingerprint(e) {
    return (this._fingerprint = e), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setLevel(e) {
    return (this._level = e), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTransactionName(e) {
    return (this._transactionName = e), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setContext(e, n) {
    return (
      n === null ? delete this._contexts[e] : (this._contexts[e] = n),
      this._notifyScopeListeners(),
      this
    );
  }
  /**
   * @inheritDoc
   */
  setSession(e) {
    return (
      e ? (this._session = e) : delete this._session,
      this._notifyScopeListeners(),
      this
    );
  }
  /**
   * @inheritDoc
   */
  getSession() {
    return this._session;
  }
  /**
   * @inheritDoc
   */
  update(e) {
    if (!e) return this;
    const n = typeof e == 'function' ? e(this) : e,
      [r, s] =
        n instanceof j
          ? [n.getScopeData(), n.getRequestSession()]
          : X(n)
          ? [e, e.requestSession]
          : [],
      {
        tags: o,
        extra: i,
        user: a,
        contexts: c,
        level: u,
        fingerprint: f = [],
        propagationContext: d,
      } = r || {};
    return (
      (this._tags = { ...this._tags, ...o }),
      (this._extra = { ...this._extra, ...i }),
      (this._contexts = { ...this._contexts, ...c }),
      a && Object.keys(a).length && (this._user = a),
      u && (this._level = u),
      f.length && (this._fingerprint = f),
      d && (this._propagationContext = d),
      s && (this._requestSession = s),
      this
    );
  }
  /**
   * @inheritDoc
   */
  clear() {
    return (
      (this._breadcrumbs = []),
      (this._tags = {}),
      (this._extra = {}),
      (this._user = {}),
      (this._contexts = {}),
      (this._level = void 0),
      (this._transactionName = void 0),
      (this._fingerprint = void 0),
      (this._requestSession = void 0),
      (this._session = void 0),
      Xt(this, void 0),
      (this._attachments = []),
      (this._propagationContext = Ue()),
      this._notifyScopeListeners(),
      this
    );
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(e, n) {
    const r = typeof n == 'number' ? n : ys;
    if (r <= 0) return this;
    const s = {
        timestamp: dt(),
        ...e,
      },
      o = this._breadcrumbs;
    return (
      o.push(s),
      (this._breadcrumbs = o.length > r ? o.slice(-r) : o),
      this._notifyScopeListeners(),
      this
    );
  }
  /**
   * @inheritDoc
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * @inheritDoc
   */
  clearBreadcrumbs() {
    return (this._breadcrumbs = []), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addAttachment(e) {
    return this._attachments.push(e), this;
  }
  /**
   * @inheritDoc
   */
  clearAttachments() {
    return (this._attachments = []), this;
  }
  /** @inheritDoc */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: wt(this),
    };
  }
  /**
   * @inheritDoc
   */
  setSDKProcessingMetadata(e) {
    return (
      (this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...e }),
      this
    );
  }
  /**
   * @inheritDoc
   */
  setPropagationContext(e) {
    return (this._propagationContext = e), this;
  }
  /**
   * @inheritDoc
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * @inheritDoc
   */
  captureException(e, n) {
    const r = n && n.event_id ? n.event_id : b();
    if (!this._client)
      return (
        l.warn('No client configured on scope - will not capture exception!'), r
      );
    const s = new Error('Sentry syntheticException');
    return (
      this._client.captureException(
        e,
        {
          originalException: e,
          syntheticException: s,
          ...n,
          event_id: r,
        },
        this,
      ),
      r
    );
  }
  /**
   * @inheritDoc
   */
  captureMessage(e, n, r) {
    const s = r && r.event_id ? r.event_id : b();
    if (!this._client)
      return (
        l.warn('No client configured on scope - will not capture message!'), s
      );
    const o = new Error(e);
    return (
      this._client.captureMessage(
        e,
        n,
        {
          originalException: e,
          syntheticException: o,
          ...r,
          event_id: s,
        },
        this,
      ),
      s
    );
  }
  /**
   * @inheritDoc
   */
  captureEvent(e, n) {
    const r = n && n.event_id ? n.event_id : b();
    return this._client
      ? (this._client.captureEvent(e, { ...n, event_id: r }, this), r)
      : (l.warn('No client configured on scope - will not capture event!'), r);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners ||
      ((this._notifyingListeners = !0),
      this._scopeListeners.forEach((e) => {
        e(this);
      }),
      (this._notifyingListeners = !1));
  }
}
const j = pe;
function Ss() {
  return $t('defaultCurrentScope', () => new j());
}
function Es() {
  return $t('defaultIsolationScope', () => new j());
}
class bs {
  constructor(e, n) {
    let r;
    e ? (r = e) : (r = new j());
    let s;
    n ? (s = n) : (s = new j()),
      (this._stack = [{ scope: r }]),
      (this._isolationScope = s);
  }
  /**
   * Fork a scope for the stack.
   */
  withScope(e) {
    const n = this._pushScope();
    let r;
    try {
      r = e(n);
    } catch (s) {
      throw (this._popScope(), s);
    }
    return Dt(r)
      ? r.then(
          (s) => (this._popScope(), s),
          (s) => {
            throw (this._popScope(), s);
          },
        )
      : (this._popScope(), r);
  }
  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    const e = this.getScope().clone();
    return (
      this._stack.push({
        client: this.getClient(),
        scope: e,
      }),
      e
    );
  }
  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    return this._stack.length <= 1 ? !1 : !!this._stack.pop();
  }
}
function Z() {
  const t = rt(),
    e = le(t);
  return (e.stack = e.stack || new bs(Ss(), Es()));
}
function Ts(t) {
  return Z().withScope(t);
}
function Is(t, e) {
  const n = Z();
  return n.withScope(() => ((n.getStackTop().scope = t), e(t)));
}
function He(t) {
  return Z().withScope(() => t(Z().getIsolationScope()));
}
function vs() {
  return {
    withIsolationScope: He,
    withScope: Ts,
    withSetScope: Is,
    withSetIsolationScope: (t, e) => He(e),
    getCurrentScope: () => Z().getScope(),
    getIsolationScope: () => Z().getIsolationScope(),
  };
}
function lt(t) {
  const e = le(t);
  return e.acs ? e.acs : vs();
}
function R() {
  const t = rt();
  return lt(t).getCurrentScope();
}
function P() {
  const t = rt();
  return lt(t).getIsolationScope();
}
function ks() {
  return $t('globalScope', () => new j());
}
function he(...t) {
  const e = rt(),
    n = lt(e);
  if (t.length === 2) {
    const [r, s] = t;
    return r ? n.withSetScope(r, s) : n.withScope(s);
  }
  return n.withScope(t[0]);
}
function S() {
  return R().getClient();
}
const Ns = '_sentryMetrics';
function Jt(t) {
  const e = t[Ns];
  if (!e) return;
  const n = {};
  for (const [, [r, s]] of e) (n[r] || (n[r] = [])).push(I(s));
  return n;
}
const _e = 'sentry.source',
  An = 'sentry.sample_rate',
  Zt = 'sentry.op',
  ut = 'sentry.origin',
  ws = 'sentry.measurement_unit',
  Rs = 'sentry.measurement_value',
  Os = 'sentry.profile_id',
  Ds = 'sentry.exclusive_time',
  As = 0,
  $s = 1,
  $n = 0,
  Cn = 1;
function Cs(t) {
  const { spanId: e, traceId: n } = t.spanContext(),
    { data: r, op: s, parent_span_id: o, status: i, origin: a } = O(t);
  return I({
    parent_span_id: o,
    span_id: e,
    trace_id: n,
    data: r,
    op: s,
    status: i,
    origin: a,
  });
}
function xs(t) {
  const { spanId: e, traceId: n } = t.spanContext(),
    { parent_span_id: r } = O(t);
  return I({ parent_span_id: r, span_id: e, trace_id: n });
}
function z(t) {
  return typeof t == 'number'
    ? Be(t)
    : Array.isArray(t)
    ? t[0] + t[1] / 1e9
    : t instanceof Date
    ? Be(t.getTime())
    : N();
}
function Be(t) {
  return t > 9999999999 ? t / 1e3 : t;
}
function O(t) {
  if (Ms(t)) return t.getSpanJSON();
  try {
    const { spanId: e, traceId: n } = t.spanContext();
    if (Ps(t)) {
      const {
        attributes: r,
        startTime: s,
        name: o,
        endTime: i,
        parentSpanId: a,
        status: c,
      } = t;
      return I({
        span_id: e,
        trace_id: n,
        data: r,
        description: o,
        parent_span_id: a,
        start_timestamp: z(s),
        // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
        timestamp: z(i) || void 0,
        status: xn(c),
        op: r[Zt],
        origin: r[ut],
        _metrics_summary: Jt(t),
      });
    }
    return {
      span_id: e,
      trace_id: n,
    };
  } catch {
    return {};
  }
}
function Ps(t) {
  const e = t;
  return (
    !!e.attributes && !!e.startTime && !!e.name && !!e.endTime && !!e.status
  );
}
function Ms(t) {
  return typeof t.getSpanJSON == 'function';
}
function pt(t) {
  const { traceFlags: e } = t.spanContext();
  return e === Cn;
}
function xn(t) {
  if (!(!t || t.code === As))
    return t.code === $s ? 'ok' : t.message || 'unknown_error';
}
const it = '_sentryChildSpans',
  Qt = '_sentryRootSpan';
function Pn(t, e) {
  const n = t[Qt] || t;
  w(e, Qt, n), t[it] ? t[it].add(e) : w(t, it, /* @__PURE__ */ new Set([e]));
}
function Ls(t) {
  const e = /* @__PURE__ */ new Set();
  function n(r) {
    if (!e.has(r) && pt(r)) {
      e.add(r);
      const s = r[it] ? Array.from(r[it]) : [];
      for (const o of s) n(o);
    }
  }
  return n(t), Array.from(e);
}
function F(t) {
  return t[Qt] || t;
}
function Ge() {
  const t = rt(),
    e = lt(t);
  return e.getActiveSpan ? e.getActiveSpan() : wt(R());
}
const Mn = '_sentryScope',
  Ln = '_sentryIsolationScope';
function Fs(t, e, n) {
  t && (w(t, Ln, n), w(t, Mn, e));
}
function We(t) {
  return {
    scope: t[Mn],
    isolationScope: t[Ln],
  };
}
function Ct(t) {
  if (typeof __SENTRY_TRACING__ == 'boolean' && !__SENTRY_TRACING__) return !1;
  const e = S(),
    n = t || (e && e.getOptions());
  return (
    !!n && (n.enableTracing || 'tracesSampleRate' in n || 'tracesSampler' in n)
  );
}
class me {
  constructor(e = {}) {
    (this._traceId = e.traceId || b()),
      (this._spanId = e.spanId || b().substring(16));
  }
  /** @inheritdoc */
  spanContext() {
    return {
      spanId: this._spanId,
      traceId: this._traceId,
      traceFlags: $n,
    };
  }
  /** @inheritdoc */
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  end(e) {}
  /** @inheritdoc */
  setAttribute(e, n) {
    return this;
  }
  /** @inheritdoc */
  setAttributes(e) {
    return this;
  }
  /** @inheritdoc */
  setStatus(e) {
    return this;
  }
  /** @inheritdoc */
  updateName(e) {
    return this;
  }
  /** @inheritdoc */
  isRecording() {
    return !1;
  }
  /** @inheritdoc */
  addEvent(e, n, r) {
    return this;
  }
  /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */
  addLink(e) {
    return this;
  }
  /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */
  addLinks(e) {
    return this;
  }
  /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */
  recordException(e, n) {}
}
const ge = 'production',
  Fn = '_frozenDsc';
function Ye(t, e) {
  w(t, Fn, e);
}
function Un(t, e) {
  const n = e.getOptions(),
    { publicKey: r } = e.getDsn() || {},
    s = I({
      environment: n.environment || ge,
      release: n.release,
      public_key: r,
      trace_id: t,
    });
  return e.emit('createDsc', s), s;
}
function xt(t) {
  const e = S();
  if (!e) return {};
  const n = Un(O(t).trace_id || '', e),
    r = F(t),
    s = r[Fn];
  if (s) return s;
  const o = r.spanContext().traceState,
    i = o && o.get('sentry.dsc'),
    a = i && Zr(i);
  if (a) return a;
  const c = O(r),
    u = c.data || {},
    f = u[An];
  f != null && (n.sample_rate = `${f}`);
  const d = u[_e],
    p = c.description;
  return (
    d !== 'url' && p && (n.transaction = p),
    Ct() && (n.sampled = String(pt(r))),
    e.emit('createDsc', n, r),
    n
  );
}
function Us(t) {
  if (!h) return;
  const {
      description: e = '< unknown name >',
      op: n = '< unknown op >',
      parent_span_id: r,
    } = O(t),
    { spanId: s } = t.spanContext(),
    o = pt(t),
    i = F(t),
    a = i === t,
    c = `[Tracing] Starting ${o ? 'sampled' : 'unsampled'} ${
      a ? 'root ' : ''
    }span`,
    u = [`op: ${n}`, `name: ${e}`, `ID: ${s}`];
  if ((r && u.push(`parent ID: ${r}`), !a)) {
    const { op: f, description: d } = O(i);
    u.push(`root ID: ${i.spanContext().spanId}`),
      f && u.push(`root op: ${f}`),
      d && u.push(`root description: ${d}`);
  }
  l.log(`${c}
  ${u.join(`
  `)}`);
}
function js(t) {
  if (!h) return;
  const { description: e = '< unknown name >', op: n = '< unknown op >' } =
      O(t),
    { spanId: r } = t.spanContext(),
    o = F(t) === t,
    i = `[Tracing] Finishing "${n}" ${
      o ? 'root ' : ''
    }span "${e}" with ID ${r}`;
  l.log(i);
}
function jn(t) {
  if (typeof t == 'boolean') return Number(t);
  const e = typeof t == 'string' ? parseFloat(t) : t;
  if (typeof e != 'number' || isNaN(e) || e < 0 || e > 1) {
    h &&
      l.warn(
        `[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(
          t,
        )} of type ${JSON.stringify(typeof t)}.`,
      );
    return;
  }
  return e;
}
function Hs(t, e) {
  if (!Ct(t)) return [!1];
  let n;
  typeof t.tracesSampler == 'function'
    ? (n = t.tracesSampler(e))
    : e.parentSampled !== void 0
    ? (n = e.parentSampled)
    : typeof t.tracesSampleRate < 'u'
    ? (n = t.tracesSampleRate)
    : (n = 1);
  const r = jn(n);
  return r === void 0
    ? (h &&
        l.warn(
          '[Tracing] Discarding transaction because of invalid sample rate.',
        ),
      [!1])
    : r
    ? Math.random() < r
      ? [!0, r]
      : (h &&
          l.log(
            `[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(
              n,
            )})`,
          ),
        [!1, r])
    : (h &&
        l.log(
          `[Tracing] Discarding transaction because ${
            typeof t.tracesSampler == 'function'
              ? 'tracesSampler returned 0 or false'
              : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'
          }`,
        ),
      [!1, r]);
}
function Bs(t, e) {
  return (
    e &&
      ((t.sdk = t.sdk || {}),
      (t.sdk.name = t.sdk.name || e.name),
      (t.sdk.version = t.sdk.version || e.version),
      (t.sdk.integrations = [
        ...(t.sdk.integrations || []),
        ...(e.integrations || []),
      ]),
      (t.sdk.packages = [...(t.sdk.packages || []), ...(e.packages || [])])),
    t
  );
}
function Gs(t, e, n, r) {
  const s = Dn(n),
    o = {
      sent_at: /* @__PURE__ */ new Date().toISOString(),
      ...(s && { sdk: s }),
      ...(!!r && e && { dsn: ft(e) }),
    },
    i =
      'aggregates' in t
        ? [{ type: 'sessions' }, t]
        : [{ type: 'session' }, t.toJSON()];
  return nt(o, [i]);
}
function Ws(t, e, n, r) {
  const s = Dn(n),
    o = t.type && t.type !== 'replay_event' ? t.type : 'event';
  Bs(t, n && n.sdk);
  const i = is(t, s, r, e);
  return delete t.sdkProcessingMetadata, nt(i, [[{ type: o }, t]]);
}
function Ys(t, e) {
  function n(f) {
    return !!f.trace_id && !!f.public_key;
  }
  const r = xt(t[0]),
    s = e && e.getDsn(),
    o = e && e.getOptions().tunnel,
    i = {
      sent_at: /* @__PURE__ */ new Date().toISOString(),
      ...(n(r) && { trace: r }),
      ...(!!o && s && { dsn: ft(s) }),
    },
    a = e && e.getOptions().beforeSendSpan,
    c = a ? (f) => a(O(f)) : (f) => O(f),
    u = [];
  for (const f of t) {
    const d = c(f);
    d && u.push(rs(d));
  }
  return nt(i, u);
}
function qe(t) {
  if (!t || t.length === 0) return;
  const e = {};
  return (
    t.forEach((n) => {
      const r = n.attributes || {},
        s = r[ws],
        o = r[Rs];
      typeof s == 'string' &&
        typeof o == 'number' &&
        (e[n.name] = { value: o, unit: s });
    }),
    e
  );
}
const Ve = 1e3;
class ye {
  /** Epoch timestamp in seconds when the span started. */
  /** Epoch timestamp in seconds when the span ended. */
  /** Internal keeper of the status */
  /** The timed events added to this span. */
  /** if true, treat span as a standalone span (not part of a transaction) */
  /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */
  constructor(e = {}) {
    (this._traceId = e.traceId || b()),
      (this._spanId = e.spanId || b().substring(16)),
      (this._startTime = e.startTimestamp || N()),
      (this._attributes = {}),
      this.setAttributes({
        [ut]: 'manual',
        [Zt]: e.op,
        ...e.attributes,
      }),
      (this._name = e.name),
      e.parentSpanId && (this._parentSpanId = e.parentSpanId),
      'sampled' in e && (this._sampled = e.sampled),
      e.endTimestamp && (this._endTime = e.endTimestamp),
      (this._events = []),
      (this._isStandaloneSpan = e.isStandalone),
      this._endTime && this._onSpanEnded();
  }
  /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */
  addLink(e) {
    return this;
  }
  /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */
  addLinks(e) {
    return this;
  }
  /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */
  recordException(e, n) {}
  /** @inheritdoc */
  spanContext() {
    const { _spanId: e, _traceId: n, _sampled: r } = this;
    return {
      spanId: e,
      traceId: n,
      traceFlags: r ? Cn : $n,
    };
  }
  /** @inheritdoc */
  setAttribute(e, n) {
    return (
      n === void 0 ? delete this._attributes[e] : (this._attributes[e] = n),
      this
    );
  }
  /** @inheritdoc */
  setAttributes(e) {
    return Object.keys(e).forEach((n) => this.setAttribute(n, e[n])), this;
  }
  /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */
  updateStartTime(e) {
    this._startTime = z(e);
  }
  /**
   * @inheritDoc
   */
  setStatus(e) {
    return (this._status = e), this;
  }
  /**
   * @inheritDoc
   */
  updateName(e) {
    return (this._name = e), this;
  }
  /** @inheritdoc */
  end(e) {
    this._endTime || ((this._endTime = z(e)), js(this), this._onSpanEnded());
  }
  /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */
  getSpanJSON() {
    return I({
      data: this._attributes,
      description: this._name,
      op: this._attributes[Zt],
      parent_span_id: this._parentSpanId,
      span_id: this._spanId,
      start_timestamp: this._startTime,
      status: xn(this._status),
      timestamp: this._endTime,
      trace_id: this._traceId,
      origin: this._attributes[ut],
      _metrics_summary: Jt(this),
      profile_id: this._attributes[Os],
      exclusive_time: this._attributes[Ds],
      measurements: qe(this._events),
      is_segment: (this._isStandaloneSpan && F(this) === this) || void 0,
      segment_id: this._isStandaloneSpan
        ? F(this).spanContext().spanId
        : void 0,
    });
  }
  /** @inheritdoc */
  isRecording() {
    return !this._endTime && !!this._sampled;
  }
  /**
   * @inheritdoc
   */
  addEvent(e, n, r) {
    h && l.log('[Tracing] Adding an event to span:', e);
    const s = Ke(n) ? n : r || N(),
      o = Ke(n) ? {} : n || {},
      i = {
        name: e,
        time: z(s),
        attributes: o,
      };
    return this._events.push(i), this;
  }
  /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */
  isStandaloneSpan() {
    return !!this._isStandaloneSpan;
  }
  /** Emit `spanEnd` when the span is ended. */
  _onSpanEnded() {
    const e = S();
    if (
      (e && e.emit('spanEnd', this),
      !(this._isStandaloneSpan || this === F(this)))
    )
      return;
    if (this._isStandaloneSpan) {
      this._sampled
        ? Vs(Ys([this], e))
        : (h &&
            l.log(
              '[Tracing] Discarding standalone span because its trace was not chosen to be sampled.',
            ),
          e && e.recordDroppedEvent('sample_rate', 'span'));
      return;
    }
    const r = this._convertSpanToTransaction();
    r && (We(this).scope || R()).captureEvent(r);
  }
  /**
   * Finish the transaction & prepare the event to send to Sentry.
   */
  _convertSpanToTransaction() {
    if (!ze(O(this))) return;
    this._name ||
      (h &&
        l.warn(
          'Transaction has no name, falling back to `<unlabeled transaction>`.',
        ),
      (this._name = '<unlabeled transaction>'));
    const { scope: e, isolationScope: n } = We(this),
      s = (e || R()).getClient() || S();
    if (this._sampled !== !0) {
      h &&
        l.log(
          '[Tracing] Discarding transaction because its trace was not chosen to be sampled.',
        ),
        s && s.recordDroppedEvent('sample_rate', 'transaction');
      return;
    }
    const i = Ls(this)
        .filter((d) => d !== this && !qs(d))
        .map((d) => O(d))
        .filter(ze),
      a = this._attributes[_e],
      c = {
        contexts: {
          trace: Cs(this),
        },
        spans:
          // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
          // we do not use spans anymore after this point
          i.length > Ve
            ? i
                .sort((d, p) => d.start_timestamp - p.start_timestamp)
                .slice(0, Ve)
            : i,
        start_timestamp: this._startTime,
        timestamp: this._endTime,
        transaction: this._name,
        type: 'transaction',
        sdkProcessingMetadata: {
          capturedSpanScope: e,
          capturedSpanIsolationScope: n,
          ...I({
            dynamicSamplingContext: xt(this),
          }),
        },
        _metrics_summary: Jt(this),
        ...(a && {
          transaction_info: {
            source: a,
          },
        }),
      },
      u = qe(this._events);
    return (
      u &&
        Object.keys(u).length &&
        (h &&
          l.log(
            '[Measurements] Adding measurements to transaction event',
            JSON.stringify(u, void 0, 2),
          ),
        (c.measurements = u)),
      c
    );
  }
}
function Ke(t) {
  return (t && typeof t == 'number') || t instanceof Date || Array.isArray(t);
}
function ze(t) {
  return !!t.start_timestamp && !!t.timestamp && !!t.span_id && !!t.trace_id;
}
function qs(t) {
  return t instanceof ye && t.isStandaloneSpan();
}
function Vs(t) {
  const e = S();
  if (!e) return;
  const n = t[1];
  if (!n || n.length === 0) {
    e.recordDroppedEvent('before_send', 'span');
    return;
  }
  e.sendEnvelope(t);
}
const Hn = '__SENTRY_SUPPRESS_TRACING__';
function Xe(t) {
  const e = Bn();
  if (e.startInactiveSpan) return e.startInactiveSpan(t);
  const n = Xs(t),
    { forceTransaction: r, parentSpan: s } = t;
  return (
    t.scope
      ? (i) => he(t.scope, i)
      : s !== void 0
      ? (i) => Ks(s, i)
      : (i) => i()
  )(() => {
    const i = R(),
      a = Zs(i);
    return t.onlyIfParent && !a
      ? new me()
      : zs({
          parentSpan: a,
          spanArguments: n,
          forceTransaction: r,
          scope: i,
        });
  });
}
function Ks(t, e) {
  const n = Bn();
  return n.withActiveSpan
    ? n.withActiveSpan(t, e)
    : he((r) => (Xt(r, t || void 0), e(r)));
}
function zs({
  parentSpan: t,
  spanArguments: e,
  forceTransaction: n,
  scope: r,
}) {
  if (!Ct()) return new me();
  const s = P();
  let o;
  if (t && !n) (o = Js(t, r, e)), Pn(t, o);
  else if (t) {
    const i = xt(t),
      { traceId: a, spanId: c } = t.spanContext(),
      u = pt(t);
    (o = Je(
      {
        traceId: a,
        parentSpanId: c,
        ...e,
      },
      r,
      u,
    )),
      Ye(o, i);
  } else {
    const {
      traceId: i,
      dsc: a,
      parentSpanId: c,
      sampled: u,
    } = {
      ...s.getPropagationContext(),
      ...r.getPropagationContext(),
    };
    (o = Je(
      {
        traceId: i,
        parentSpanId: c,
        ...e,
      },
      r,
      u,
    )),
      a && Ye(o, a);
  }
  return Us(o), Fs(o, r, s), o;
}
function Xs(t) {
  const n = {
    isStandalone: (t.experimental || {}).standalone,
    ...t,
  };
  if (t.startTime) {
    const r = { ...n };
    return (r.startTimestamp = z(t.startTime)), delete r.startTime, r;
  }
  return n;
}
function Bn() {
  const t = rt();
  return lt(t);
}
function Je(t, e, n) {
  const r = S(),
    s = (r && r.getOptions()) || {},
    { name: o = '', attributes: i } = t,
    [a, c] = e.getScopeData().sdkProcessingMetadata[Hn]
      ? [!1]
      : Hs(s, {
          name: o,
          parentSampled: n,
          attributes: i,
          transactionContext: {
            name: o,
            parentSampled: n,
          },
        }),
    u = new ye({
      ...t,
      attributes: {
        [_e]: 'custom',
        ...t.attributes,
      },
      sampled: a,
    });
  return c !== void 0 && u.setAttribute(An, c), r && r.emit('spanStart', u), u;
}
function Js(t, e, n) {
  const { spanId: r, traceId: s } = t.spanContext(),
    o = e.getScopeData().sdkProcessingMetadata[Hn] ? !1 : pt(t),
    i = o
      ? new ye({
          ...n,
          parentSpanId: r,
          traceId: s,
          sampled: o,
        })
      : new me({ traceId: s });
  Pn(t, i);
  const a = S();
  return (
    a && (a.emit('spanStart', i), n.endTimestamp && a.emit('spanEnd', i)), i
  );
}
function Zs(t) {
  const e = wt(t);
  if (!e) return;
  const n = S();
  return (n ? n.getOptions() : {}).parentSpanIsAlwaysRootSpan ? F(e) : e;
}
function te(t, e, n, r = 0) {
  return new k((s, o) => {
    const i = t[r];
    if (e === null || typeof i != 'function') s(e);
    else {
      const a = i({ ...e }, n);
      h &&
        i.id &&
        a === null &&
        l.log(`Event processor "${i.id}" dropped event`),
        Dt(a)
          ? a.then((c) => te(t, c, n, r + 1).then(s)).then(null, o)
          : te(t, a, n, r + 1)
              .then(s)
              .then(null, o);
    }
  });
}
function Qs(t, e) {
  const {
    fingerprint: n,
    span: r,
    breadcrumbs: s,
    sdkProcessingMetadata: o,
  } = e;
  to(t, e), r && ro(t, r), so(t, n), eo(t, s), no(t, o);
}
function Ze(t, e) {
  const {
    extra: n,
    tags: r,
    user: s,
    contexts: o,
    level: i,
    sdkProcessingMetadata: a,
    breadcrumbs: c,
    fingerprint: u,
    eventProcessors: f,
    attachments: d,
    propagationContext: p,
    transactionName: m,
    span: _,
  } = e;
  st(t, 'extra', n),
    st(t, 'tags', r),
    st(t, 'user', s),
    st(t, 'contexts', o),
    st(t, 'sdkProcessingMetadata', a),
    i && (t.level = i),
    m && (t.transactionName = m),
    _ && (t.span = _),
    c.length && (t.breadcrumbs = [...t.breadcrumbs, ...c]),
    u.length && (t.fingerprint = [...t.fingerprint, ...u]),
    f.length && (t.eventProcessors = [...t.eventProcessors, ...f]),
    d.length && (t.attachments = [...t.attachments, ...d]),
    (t.propagationContext = { ...t.propagationContext, ...p });
}
function st(t, e, n) {
  if (n && Object.keys(n).length) {
    t[e] = { ...t[e] };
    for (const r in n)
      Object.prototype.hasOwnProperty.call(n, r) && (t[e][r] = n[r]);
  }
}
function to(t, e) {
  const {
      extra: n,
      tags: r,
      user: s,
      contexts: o,
      level: i,
      transactionName: a,
    } = e,
    c = I(n);
  c && Object.keys(c).length && (t.extra = { ...c, ...t.extra });
  const u = I(r);
  u && Object.keys(u).length && (t.tags = { ...u, ...t.tags });
  const f = I(s);
  f && Object.keys(f).length && (t.user = { ...f, ...t.user });
  const d = I(o);
  d && Object.keys(d).length && (t.contexts = { ...d, ...t.contexts }),
    i && (t.level = i),
    a && t.type !== 'transaction' && (t.transaction = a);
}
function eo(t, e) {
  const n = [...(t.breadcrumbs || []), ...e];
  t.breadcrumbs = n.length ? n : void 0;
}
function no(t, e) {
  t.sdkProcessingMetadata = {
    ...t.sdkProcessingMetadata,
    ...e,
  };
}
function ro(t, e) {
  (t.contexts = {
    trace: xs(e),
    ...t.contexts,
  }),
    (t.sdkProcessingMetadata = {
      dynamicSamplingContext: xt(e),
      ...t.sdkProcessingMetadata,
    });
  const n = F(e),
    r = O(n).description;
  r && !t.transaction && t.type === 'transaction' && (t.transaction = r);
}
function so(t, e) {
  (t.fingerprint = t.fingerprint ? de(t.fingerprint) : []),
    e && (t.fingerprint = t.fingerprint.concat(e)),
    t.fingerprint && !t.fingerprint.length && delete t.fingerprint;
}
function oo(t, e, n, r, s, o) {
  const { normalizeDepth: i = 3, normalizeMaxBreadth: a = 1e3 } = t,
    c = {
      ...e,
      event_id: e.event_id || n.event_id || b(),
      timestamp: e.timestamp || dt(),
    },
    u = n.integrations || t.integrations.map((T) => T.name);
  io(c, t),
    uo(c, u),
    s && s.emit('applyFrameMetadata', e),
    e.type === void 0 && ao(c, t.stackParser);
  const f = lo(r, n.captureContext);
  n.mechanism && ct(c, n.mechanism);
  const d = s ? s.getEventProcessors() : [],
    p = ks().getScopeData();
  if (o) {
    const T = o.getScopeData();
    Ze(p, T);
  }
  if (f) {
    const T = f.getScopeData();
    Ze(p, T);
  }
  const m = [...(n.attachments || []), ...p.attachments];
  m.length && (n.attachments = m), Qs(c, p);
  const _ = [
    ...d,
    // Run scope event processors _after_ all other processors
    ...p.eventProcessors,
  ];
  return te(_, c, n).then(
    (T) => (T && co(T), typeof i == 'number' && i > 0 ? fo(T, i, a) : T),
  );
}
function io(t, e) {
  const { environment: n, release: r, dist: s, maxValueLength: o = 250 } = e;
  'environment' in t || (t.environment = 'environment' in e ? n : ge),
    t.release === void 0 && r !== void 0 && (t.release = r),
    t.dist === void 0 && s !== void 0 && (t.dist = s),
    t.message && (t.message = K(t.message, o));
  const i = t.exception && t.exception.values && t.exception.values[0];
  i && i.value && (i.value = K(i.value, o));
  const a = t.request;
  a && a.url && (a.url = K(a.url, o));
}
function ao(t, e) {
  const n = ps(e);
  try {
    t.exception.values.forEach((r) => {
      r.stacktrace.frames.forEach((s) => {
        s.filename && (s.debug_id = n[s.filename]);
      });
    });
  } catch {}
}
function co(t) {
  const e = {};
  try {
    t.exception.values.forEach((r) => {
      r.stacktrace.frames.forEach((s) => {
        s.debug_id &&
          (s.abs_path
            ? (e[s.abs_path] = s.debug_id)
            : s.filename && (e[s.filename] = s.debug_id),
          delete s.debug_id);
      });
    });
  } catch {}
  if (Object.keys(e).length === 0) return;
  (t.debug_meta = t.debug_meta || {}),
    (t.debug_meta.images = t.debug_meta.images || []);
  const n = t.debug_meta.images;
  Object.entries(e).forEach(([r, s]) => {
    n.push({
      type: 'sourcemap',
      code_file: r,
      debug_id: s,
    });
  });
}
function uo(t, e) {
  e.length > 0 &&
    ((t.sdk = t.sdk || {}),
    (t.sdk.integrations = [...(t.sdk.integrations || []), ...e]));
}
function fo(t, e, n) {
  if (!t) return null;
  const r = {
    ...t,
    ...(t.breadcrumbs && {
      breadcrumbs: t.breadcrumbs.map((s) => ({
        ...s,
        ...(s.data && {
          data: L(s.data, e, n),
        }),
      })),
    }),
    ...(t.user && {
      user: L(t.user, e, n),
    }),
    ...(t.contexts && {
      contexts: L(t.contexts, e, n),
    }),
    ...(t.extra && {
      extra: L(t.extra, e, n),
    }),
  };
  return (
    t.contexts &&
      t.contexts.trace &&
      r.contexts &&
      ((r.contexts.trace = t.contexts.trace),
      t.contexts.trace.data &&
        (r.contexts.trace.data = L(t.contexts.trace.data, e, n))),
    t.spans &&
      (r.spans = t.spans.map((s) => ({
        ...s,
        ...(s.data && {
          data: L(s.data, e, n),
        }),
      }))),
    r
  );
}
function lo(t, e) {
  if (!e) return t;
  const n = t ? t.clone() : new j();
  return n.update(e), n;
}
function po(t) {
  if (t)
    return ho(t)
      ? { captureContext: t }
      : mo(t)
      ? {
          captureContext: t,
        }
      : t;
}
function ho(t) {
  return t instanceof j || typeof t == 'function';
}
const _o = [
  'user',
  'level',
  'extra',
  'contexts',
  'tags',
  'fingerprint',
  'requestSession',
  'propagationContext',
];
function mo(t) {
  return Object.keys(t).some((e) => _o.includes(e));
}
function Se(t, e) {
  return R().captureException(t, po(e));
}
function Gn(t, e) {
  return R().captureEvent(t, e);
}
function go(t) {
  P().setTags(t);
}
function yo(t) {
  P().setUser(t);
}
function So(t) {
  P().addEventProcessor(t);
}
function Qe(t) {
  const e = S(),
    n = P(),
    r = R(),
    { release: s, environment: o = ge } = (e && e.getOptions()) || {},
    { userAgent: i } = g.navigator || {},
    a = _s({
      release: s,
      environment: o,
      user: r.getUser() || n.getUser(),
      ...(i && { userAgent: i }),
      ...t,
    }),
    c = n.getSession();
  return (
    c && c.status === 'ok' && J(c, { status: 'exited' }),
    Wn(),
    n.setSession(a),
    r.setSession(a),
    a
  );
}
function Wn() {
  const t = P(),
    e = R(),
    n = e.getSession() || t.getSession();
  n && ms(n), Yn(), t.setSession(), e.setSession();
}
function Yn() {
  const t = P(),
    e = R(),
    n = S(),
    r = e.getSession() || t.getSession();
  r && n && n.captureSession(r);
}
function tn(t = !1) {
  if (t) {
    Wn();
    return;
  }
  Yn();
}
const Eo = '7';
function bo(t) {
  const e = t.protocol ? `${t.protocol}:` : '',
    n = t.port ? `:${t.port}` : '';
  return `${e}//${t.host}${n}${t.path ? `/${t.path}` : ''}/api/`;
}
function To(t) {
  return `${bo(t)}${t.projectId}/envelope/`;
}
function Io(t, e) {
  return kr({
    // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    sentry_key: t.publicKey,
    sentry_version: Eo,
    ...(e && { sentry_client: `${e.name}/${e.version}` }),
  });
}
function vo(t, e, n) {
  return e || `${To(t)}?${Io(t, n)}`;
}
const en = [];
function ko(t) {
  const e = {};
  return (
    t.forEach((n) => {
      const { name: r } = n,
        s = e[r];
      (s && !s.isDefaultInstance && n.isDefaultInstance) || (e[r] = n);
    }),
    Object.values(e)
  );
}
function No(t) {
  const e = t.defaultIntegrations || [],
    n = t.integrations;
  e.forEach((i) => {
    i.isDefaultInstance = !0;
  });
  let r;
  Array.isArray(n)
    ? (r = [...e, ...n])
    : typeof n == 'function'
    ? (r = de(n(e)))
    : (r = e);
  const s = ko(r),
    o = s.findIndex((i) => i.name === 'Debug');
  if (o > -1) {
    const [i] = s.splice(o, 1);
    s.push(i);
  }
  return s;
}
function wo(t, e) {
  const n = {};
  return (
    e.forEach((r) => {
      r && qn(t, r, n);
    }),
    n
  );
}
function nn(t, e) {
  for (const n of e) n && n.afterAllSetup && n.afterAllSetup(t);
}
function qn(t, e, n) {
  if (n[e.name]) {
    h &&
      l.log(`Integration skipped because it was already installed: ${e.name}`);
    return;
  }
  if (
    ((n[e.name] = e),
    en.indexOf(e.name) === -1 &&
      typeof e.setupOnce == 'function' &&
      (e.setupOnce(), en.push(e.name)),
    e.setup && typeof e.setup == 'function' && e.setup(t),
    typeof e.preprocessEvent == 'function')
  ) {
    const r = e.preprocessEvent.bind(e);
    t.on('preprocessEvent', (s, o) => r(s, o, t));
  }
  if (typeof e.processEvent == 'function') {
    const r = e.processEvent.bind(e),
      s = Object.assign((o, i) => r(o, i, t), {
        id: e.name,
      });
    t.addEventProcessor(s);
  }
  h && l.log(`Integration installed: ${e.name}`);
}
const rn = "Not capturing exception because it's already been captured.";
class Ro {
  /** Options passed to the SDK. */
  /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */
  /** Array of set up integrations. */
  /** Number of calls being processed */
  /** Holds flushable  */
  // eslint-disable-next-line @typescript-eslint/ban-types
  /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */
  constructor(e) {
    if (
      ((this._options = e),
      (this._integrations = {}),
      (this._numProcessing = 0),
      (this._outcomes = {}),
      (this._hooks = {}),
      (this._eventProcessors = []),
      e.dsn
        ? (this._dsn = vr(e.dsn))
        : h && l.warn('No DSN provided, client will not send events.'),
      this._dsn)
    ) {
      const n = vo(this._dsn, e.tunnel, e._metadata ? e._metadata.sdk : void 0);
      this._transport = e.transport({
        tunnel: this._options.tunnel,
        recordDroppedEvent: this.recordDroppedEvent.bind(this),
        ...e.transportOptions,
        url: n,
      });
    }
  }
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  captureException(e, n, r) {
    const s = b();
    if (Pe(e)) return h && l.log(rn), s;
    const o = {
      event_id: s,
      ...n,
    };
    return (
      this._process(
        this.eventFromException(e, o).then((i) => this._captureEvent(i, o, r)),
      ),
      o.event_id
    );
  }
  /**
   * @inheritDoc
   */
  captureMessage(e, n, r, s) {
    const o = {
        event_id: b(),
        ...r,
      },
      i = ae(e) ? e : String(e),
      a = ce(e)
        ? this.eventFromMessage(i, n, o)
        : this.eventFromException(e, o);
    return (
      this._process(a.then((c) => this._captureEvent(c, o, s))), o.event_id
    );
  }
  /**
   * @inheritDoc
   */
  captureEvent(e, n, r) {
    const s = b();
    if (n && n.originalException && Pe(n.originalException))
      return h && l.log(rn), s;
    const o = {
        event_id: s,
        ...n,
      },
      a = (e.sdkProcessingMetadata || {}).capturedSpanScope;
    return this._process(this._captureEvent(e, o, a || r)), o.event_id;
  }
  /**
   * @inheritDoc
   */
  captureSession(e) {
    typeof e.release != 'string'
      ? h &&
        l.warn('Discarded session because of missing or non-string release')
      : (this.sendSession(e), J(e, { init: !1 }));
  }
  /**
   * @inheritDoc
   */
  getDsn() {
    return this._dsn;
  }
  /**
   * @inheritDoc
   */
  getOptions() {
    return this._options;
  }
  /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */
  getSdkMetadata() {
    return this._options._metadata;
  }
  /**
   * @inheritDoc
   */
  getTransport() {
    return this._transport;
  }
  /**
   * @inheritDoc
   */
  flush(e) {
    const n = this._transport;
    return n
      ? (this.emit('flush'),
        this._isClientDoneProcessing(e).then((r) =>
          n.flush(e).then((s) => r && s),
        ))
      : Y(!0);
  }
  /**
   * @inheritDoc
   */
  close(e) {
    return this.flush(e).then(
      (n) => ((this.getOptions().enabled = !1), this.emit('close'), n),
    );
  }
  /** Get all installed event processors. */
  getEventProcessors() {
    return this._eventProcessors;
  }
  /** @inheritDoc */
  addEventProcessor(e) {
    this._eventProcessors.push(e);
  }
  /** @inheritdoc */
  init() {
    (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
      // Spotlight enabled. This is particularly important for browser as we
      // don't support the `spotlight` option there and rely on the users
      // adding the `spotlightBrowserIntegration()` to their integrations which
      // wouldn't get initialized with the check below when there's no DSN set.
      this._options.integrations.some(({ name: e }) =>
        e.startsWith('Spotlight'),
      )) &&
      this._setupIntegrations();
  }
  /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */
  getIntegrationByName(e) {
    return this._integrations[e];
  }
  /**
   * @inheritDoc
   */
  addIntegration(e) {
    const n = this._integrations[e.name];
    qn(this, e, this._integrations), n || nn(this, [e]);
  }
  /**
   * @inheritDoc
   */
  sendEvent(e, n = {}) {
    this.emit('beforeSendEvent', e, n);
    let r = Ws(e, this._dsn, this._options._metadata, this._options.tunnel);
    for (const o of n.attachments || []) r = ts(r, ss(o));
    const s = this.sendEnvelope(r);
    s && s.then((o) => this.emit('afterSendEvent', e, o), null);
  }
  /**
   * @inheritDoc
   */
  sendSession(e) {
    const n = Gs(e, this._dsn, this._options._metadata, this._options.tunnel);
    this.sendEnvelope(n);
  }
  /**
   * @inheritDoc
   */
  recordDroppedEvent(e, n, r) {
    if (this._options.sendClientReports) {
      const s = typeof r == 'number' ? r : 1,
        o = `${e}:${n}`;
      h && l.log(`Recording outcome: "${o}"${s > 1 ? ` (${s} times)` : ''}`),
        (this._outcomes[o] = (this._outcomes[o] || 0) + s);
    }
  }
  // Keep on() & emit() signatures in sync with types' client.ts interface
  /* eslint-disable @typescript-eslint/unified-signatures */
  /** @inheritdoc */
  /** @inheritdoc */
  on(e, n) {
    const r = (this._hooks[e] = this._hooks[e] || []);
    return (
      r.push(n),
      () => {
        const s = r.indexOf(n);
        s > -1 && r.splice(s, 1);
      }
    );
  }
  /** @inheritdoc */
  /** @inheritdoc */
  emit(e, ...n) {
    const r = this._hooks[e];
    r && r.forEach((s) => s(...n));
  }
  /**
   * @inheritdoc
   */
  sendEnvelope(e) {
    return (
      this.emit('beforeEnvelope', e),
      this._isEnabled() && this._transport
        ? this._transport
            .send(e)
            .then(
              null,
              (n) => (h && l.error('Error while sending envelope:', n), n),
            )
        : (h && l.error('Transport disabled'), Y({}))
    );
  }
  /* eslint-enable @typescript-eslint/unified-signatures */
  /** Setup integrations for this client. */
  _setupIntegrations() {
    const { integrations: e } = this._options;
    (this._integrations = wo(this, e)), nn(this, e);
  }
  /** Updates existing session based on the provided event */
  _updateSessionFromEvent(e, n) {
    let r = !1,
      s = !1;
    const o = n.exception && n.exception.values;
    if (o) {
      s = !0;
      for (const c of o) {
        const u = c.mechanism;
        if (u && u.handled === !1) {
          r = !0;
          break;
        }
      }
    }
    const i = e.status === 'ok';
    ((i && e.errors === 0) || (i && r)) &&
      (J(e, {
        ...(r && { status: 'crashed' }),
        errors: e.errors || Number(s || r),
      }),
      this.captureSession(e));
  }
  /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */
  _isClientDoneProcessing(e) {
    return new k((n) => {
      let r = 0;
      const s = 1,
        o = setInterval(() => {
          this._numProcessing == 0
            ? (clearInterval(o), n(!0))
            : ((r += s), e && r >= e && (clearInterval(o), n(!1)));
        }, s);
    });
  }
  /** Determines whether this SDK is enabled and a transport is present. */
  _isEnabled() {
    return this.getOptions().enabled !== !1 && this._transport !== void 0;
  }
  /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */
  _prepareEvent(e, n, r, s = P()) {
    const o = this.getOptions(),
      i = Object.keys(this._integrations);
    return (
      !n.integrations && i.length > 0 && (n.integrations = i),
      this.emit('preprocessEvent', e, n),
      e.type || s.setLastEventId(e.event_id || n.event_id),
      oo(o, e, n, r, this, s).then((a) => {
        if (a === null) return a;
        const c = {
          ...s.getPropagationContext(),
          ...(r ? r.getPropagationContext() : void 0),
        };
        if (!(a.contexts && a.contexts.trace) && c) {
          const { traceId: f, spanId: d, parentSpanId: p, dsc: m } = c;
          a.contexts = {
            trace: I({
              trace_id: f,
              span_id: d,
              parent_span_id: p,
            }),
            ...a.contexts,
          };
          const _ = m || Un(f, this);
          a.sdkProcessingMetadata = {
            dynamicSamplingContext: _,
            ...a.sdkProcessingMetadata,
          };
        }
        return a;
      })
    );
  }
  /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */
  _captureEvent(e, n = {}, r) {
    return this._processEvent(e, n, r).then(
      (s) => s.event_id,
      (s) => {
        if (h) {
          const o = s;
          o.logLevel === 'log' ? l.log(o.message) : l.warn(o);
        }
      },
    );
  }
  /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */
  _processEvent(e, n, r) {
    const s = this.getOptions(),
      { sampleRate: o } = s,
      i = Kn(e),
      a = Vn(e),
      c = e.type || 'error',
      u = `before send for type \`${c}\``,
      f = typeof o > 'u' ? void 0 : jn(o);
    if (a && typeof f == 'number' && Math.random() > f)
      return (
        this.recordDroppedEvent('sample_rate', 'error', e),
        Nt(
          new A(
            `Discarding event because it's not included in the random sample (sampling rate = ${o})`,
            'log',
          ),
        )
      );
    const d = c === 'replay_event' ? 'replay' : c,
      m = (e.sdkProcessingMetadata || {}).capturedSpanIsolationScope;
    return this._prepareEvent(e, n, r, m)
      .then((_) => {
        if (_ === null)
          throw (
            (this.recordDroppedEvent('event_processor', d, e),
            new A(
              'An event processor returned `null`, will not send event.',
              'log',
            ))
          );
        if (n.data && n.data.__sentry__ === !0) return _;
        const T = Do(this, s, _, n);
        return Oo(T, u);
      })
      .then((_) => {
        if (_ === null) {
          if ((this.recordDroppedEvent('before_send', d, e), i)) {
            const Pt = 1 + (e.spans || []).length;
            this.recordDroppedEvent('before_send', 'span', Pt);
          }
          throw new A(`${u} returned \`null\`, will not send event.`, 'log');
        }
        const _t = r && r.getSession();
        if ((!i && _t && this._updateSessionFromEvent(_t, _), i)) {
          const mt =
              (_.sdkProcessingMetadata &&
                _.sdkProcessingMetadata.spanCountBeforeProcessing) ||
              0,
            Pt = _.spans ? _.spans.length : 0,
            Ie = mt - Pt;
          Ie > 0 && this.recordDroppedEvent('before_send', 'span', Ie);
        }
        const T = _.transaction_info;
        if (i && T && _.transaction !== e.transaction) {
          const mt = 'custom';
          _.transaction_info = {
            ...T,
            source: mt,
          };
        }
        return this.sendEvent(_, n), _;
      })
      .then(null, (_) => {
        throw _ instanceof A
          ? _
          : (this.captureException(_, {
              data: {
                __sentry__: !0,
              },
              originalException: _,
            }),
            new A(
              `Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.
Reason: ${_}`,
            ));
      });
  }
  /**
   * Occupies the client with processing and event
   */
  _process(e) {
    this._numProcessing++,
      e.then(
        (n) => (this._numProcessing--, n),
        (n) => (this._numProcessing--, n),
      );
  }
  /**
   * Clears outcomes on this client and returns them.
   */
  _clearOutcomes() {
    const e = this._outcomes;
    return (
      (this._outcomes = {}),
      Object.entries(e).map(([n, r]) => {
        const [s, o] = n.split(':');
        return {
          reason: s,
          category: o,
          quantity: r,
        };
      })
    );
  }
  /**
   * Sends client reports as an envelope.
   */
  _flushOutcomes() {
    h && l.log('Flushing outcomes...');
    const e = this._clearOutcomes();
    if (e.length === 0) {
      h && l.log('No outcomes to send');
      return;
    }
    if (!this._dsn) {
      h && l.log('No dsn provided, will not send outcomes');
      return;
    }
    h && l.log('Sending outcomes:', e);
    const n = as(e, this._options.tunnel && ft(this._dsn));
    this.sendEnvelope(n);
  }
  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
}
function Oo(t, e) {
  const n = `${e} must return \`null\` or a valid event.`;
  if (Dt(t))
    return t.then(
      (r) => {
        if (!X(r) && r !== null) throw new A(n);
        return r;
      },
      (r) => {
        throw new A(`${e} rejected with ${r}`);
      },
    );
  if (!X(t) && t !== null) throw new A(n);
  return t;
}
function Do(t, e, n, r) {
  const { beforeSend: s, beforeSendTransaction: o, beforeSendSpan: i } = e;
  if (Vn(n) && s) return s(n, r);
  if (Kn(n)) {
    if (n.spans && i) {
      const a = [];
      for (const c of n.spans) {
        const u = i(c);
        u ? a.push(u) : t.recordDroppedEvent('before_send', 'span');
      }
      n.spans = a;
    }
    if (o) {
      if (n.spans) {
        const a = n.spans.length;
        n.sdkProcessingMetadata = {
          ...n.sdkProcessingMetadata,
          spanCountBeforeProcessing: a,
        };
      }
      return o(n, r);
    }
  }
  return n;
}
function Vn(t) {
  return t.type === void 0;
}
function Kn(t) {
  return t.type === 'transaction';
}
function Ao(t, e) {
  e.debug === !0 &&
    (h
      ? l.enable()
      : B(() => {
          console.warn(
            '[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.',
          );
        })),
    R().update(e.initialScope);
  const r = new t(e);
  return $o(r), r.init(), r;
}
function $o(t) {
  R().setClient(t);
}
const Co = 64;
function xo(t, e, n = Vr(t.bufferSize || Co)) {
  let r = {};
  const s = (i) => n.drain(i);
  function o(i) {
    const a = [];
    if (
      (Le(i, (d, p) => {
        const m = Fe(p);
        if (ds(r, m)) {
          const _ = sn(d, p);
          t.recordDroppedEvent('ratelimit_backoff', m, _);
        } else a.push(d);
      }),
      a.length === 0)
    )
      return Y({});
    const c = nt(i[0], a),
      u = (d) => {
        Le(c, (p, m) => {
          const _ = sn(p, m);
          t.recordDroppedEvent(d, Fe(m), _);
        });
      },
      f = () =>
        e({ body: es(c) }).then(
          (d) => (
            d.statusCode !== void 0 &&
              (d.statusCode < 200 || d.statusCode >= 300) &&
              h &&
              l.warn(
                `Sentry responded with status code ${d.statusCode} to sent event.`,
              ),
            (r = ls(r, d)),
            d
          ),
          (d) => {
            throw (u('network_error'), d);
          },
        );
    return n.add(f).then(
      (d) => d,
      (d) => {
        if (d instanceof A)
          return (
            h && l.error('Skipped sending event because buffer is full.'),
            u('queue_overflow'),
            Y({})
          );
        throw d;
      },
    );
  }
  return {
    send: o,
    flush: s,
  };
}
function sn(t, e) {
  if (!(e !== 'event' && e !== 'transaction'))
    return Array.isArray(t) ? t[1] : void 0;
}
function Po(t, e, n = [e], r = 'npm') {
  const s = t._metadata || {};
  s.sdk ||
    (s.sdk = {
      name: `sentry.javascript.${e}`,
      packages: n.map((o) => ({
        name: `${r}:@sentry/${o}`,
        version: x,
      })),
      version: x,
    }),
    (t._metadata = s);
}
const Mo = 100;
function H(t, e) {
  const n = S(),
    r = P();
  if (!n) return;
  const { beforeBreadcrumb: s = null, maxBreadcrumbs: o = Mo } = n.getOptions();
  if (o <= 0) return;
  const a = { timestamp: dt(), ...t },
    c = s ? B(() => s(a, e)) : a;
  c !== null &&
    (n.emit && n.emit('beforeAddBreadcrumb', c, e), r.addBreadcrumb(c, o));
}
let on;
const Lo = 'FunctionToString',
  an = /* @__PURE__ */ new WeakMap(),
  Fo = () => ({
    name: Lo,
    setupOnce() {
      on = Function.prototype.toString;
      try {
        Function.prototype.toString = function (...t) {
          const e = fe(this),
            n = an.has(S()) && e !== void 0 ? e : this;
          return on.apply(n, t);
        };
      } catch {}
    },
    setup(t) {
      an.set(t, !0);
    },
  }),
  Uo = Fo,
  jo = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    // The browser logs this when a ResizeObserver handler takes a bit longer. Usually this is not an actual issue though. It indicates slowness.
    /^Cannot redefine property: googletag$/,
    // This is thrown when google tag manager is used in combination with an ad blocker
    "undefined is not an object (evaluating 'a.L')",
    // Random error that happens but not actionable or noticeable to end-users.
    `can't redefine non-configurable property "solana"`,
    // Probably a browser extension or custom browser (Brave) throwing this error
    "vv().getRestrictions is not a function. (In 'vv().getRestrictions(1,a)', 'vv().getRestrictions' is undefined)",
    // Error thrown by GTM, seemingly not affecting end-users
    "Can't find variable: _AutofillCallbackHandler",
    // Unactionable error in instagram webview https://developers.facebook.com/community/threads/320013549791141/
  ],
  Ho = 'InboundFilters',
  Bo = (t = {}) => ({
    name: Ho,
    processEvent(e, n, r) {
      const s = r.getOptions(),
        o = Wo(t, s);
      return Yo(e, o) ? null : e;
    },
  }),
  Go = Bo;
function Wo(t = {}, e = {}) {
  return {
    allowUrls: [...(t.allowUrls || []), ...(e.allowUrls || [])],
    denyUrls: [...(t.denyUrls || []), ...(e.denyUrls || [])],
    ignoreErrors: [
      ...(t.ignoreErrors || []),
      ...(e.ignoreErrors || []),
      ...(t.disableErrorDefaults ? [] : jo),
    ],
    ignoreTransactions: [
      ...(t.ignoreTransactions || []),
      ...(e.ignoreTransactions || []),
    ],
    ignoreInternal: t.ignoreInternal !== void 0 ? t.ignoreInternal : !0,
  };
}
function Yo(t, e) {
  return e.ignoreInternal && Jo(t)
    ? (h &&
        l.warn(`Event dropped due to being internal Sentry Error.
Event: ${M(t)}`),
      !0)
    : qo(t, e.ignoreErrors)
    ? (h &&
        l.warn(
          `Event dropped due to being matched by \`ignoreErrors\` option.
Event: ${M(t)}`,
        ),
      !0)
    : Qo(t)
    ? (h &&
        l.warn(
          `Event dropped due to not having an error message, error type or stacktrace.
Event: ${M(t)}`,
        ),
      !0)
    : Vo(t, e.ignoreTransactions)
    ? (h &&
        l.warn(
          `Event dropped due to being matched by \`ignoreTransactions\` option.
Event: ${M(t)}`,
        ),
      !0)
    : Ko(t, e.denyUrls)
    ? (h &&
        l.warn(
          `Event dropped due to being matched by \`denyUrls\` option.
Event: ${M(t)}.
Url: ${Rt(t)}`,
        ),
      !0)
    : zo(t, e.allowUrls)
    ? !1
    : (h &&
        l.warn(
          `Event dropped due to not being matched by \`allowUrls\` option.
Event: ${M(t)}.
Url: ${Rt(t)}`,
        ),
      !0);
}
function qo(t, e) {
  return t.type || !e || !e.length ? !1 : Xo(t).some((n) => At(n, e));
}
function Vo(t, e) {
  if (t.type !== 'transaction' || !e || !e.length) return !1;
  const n = t.transaction;
  return n ? At(n, e) : !1;
}
function Ko(t, e) {
  if (!e || !e.length) return !1;
  const n = Rt(t);
  return n ? At(n, e) : !1;
}
function zo(t, e) {
  if (!e || !e.length) return !0;
  const n = Rt(t);
  return n ? At(n, e) : !0;
}
function Xo(t) {
  const e = [];
  t.message && e.push(t.message);
  let n;
  try {
    n = t.exception.values[t.exception.values.length - 1];
  } catch {}
  return (
    n &&
      n.value &&
      (e.push(n.value), n.type && e.push(`${n.type}: ${n.value}`)),
    e
  );
}
function Jo(t) {
  try {
    return t.exception.values[0].type === 'SentryError';
  } catch {}
  return !1;
}
function Zo(t = []) {
  for (let e = t.length - 1; e >= 0; e--) {
    const n = t[e];
    if (n && n.filename !== '<anonymous>' && n.filename !== '[native code]')
      return n.filename || null;
  }
  return null;
}
function Rt(t) {
  try {
    let e;
    try {
      e = t.exception.values[0].stacktrace.frames;
    } catch {}
    return e ? Zo(e) : null;
  } catch {
    return h && l.error(`Cannot extract url for event ${M(t)}`), null;
  }
}
function Qo(t) {
  return t.type ||
    !t.exception ||
    !t.exception.values ||
    t.exception.values.length === 0
    ? !1
    : // No top-level message
      !t.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
        !t.exception.values.some(
          (e) => e.stacktrace || (e.type && e.type !== 'Error') || e.value,
        );
}
const ti = 'Dedupe',
  ei = () => {
    let t;
    return {
      name: ti,
      processEvent(e) {
        if (e.type) return e;
        try {
          if (ri(e, t))
            return (
              h &&
                l.warn(
                  'Event dropped due to being a duplicate of previously captured event.',
                ),
              null
            );
        } catch {}
        return (t = e);
      },
    };
  },
  ni = ei;
function ri(t, e) {
  return e ? !!(si(t, e) || oi(t, e)) : !1;
}
function si(t, e) {
  const n = t.message,
    r = e.message;
  return !(
    (!n && !r) ||
    (n && !r) ||
    (!n && r) ||
    n !== r ||
    !Xn(t, e) ||
    !zn(t, e)
  );
}
function oi(t, e) {
  const n = cn(e),
    r = cn(t);
  return !(
    !n ||
    !r ||
    n.type !== r.type ||
    n.value !== r.value ||
    !Xn(t, e) ||
    !zn(t, e)
  );
}
function zn(t, e) {
  let n = $e(t),
    r = $e(e);
  if (!n && !r) return !0;
  if ((n && !r) || (!n && r) || ((n = n), (r = r), r.length !== n.length))
    return !1;
  for (let s = 0; s < r.length; s++) {
    const o = r[s],
      i = n[s];
    if (
      o.filename !== i.filename ||
      o.lineno !== i.lineno ||
      o.colno !== i.colno ||
      o.function !== i.function
    )
      return !1;
  }
  return !0;
}
function Xn(t, e) {
  let n = t.fingerprint,
    r = e.fingerprint;
  if (!n && !r) return !0;
  if ((n && !r) || (!n && r)) return !1;
  (n = n), (r = r);
  try {
    return n.join('') === r.join('');
  } catch {
    return !1;
  }
}
function cn(t) {
  return t.exception && t.exception.values && t.exception.values[0];
}
const y = g;
let ee = 0;
function Jn() {
  return ee > 0;
}
function ii() {
  ee++,
    setTimeout(() => {
      ee--;
    });
}
function Q(t, e = {}, n) {
  if (typeof t != 'function') return t;
  try {
    const s = t.__sentry_wrapped__;
    if (s) return typeof s == 'function' ? s : t;
    if (fe(t)) return t;
  } catch {
    return t;
  }
  const r = function () {
    const s = Array.prototype.slice.call(arguments);
    try {
      const o = s.map((i) => Q(i, e));
      return t.apply(this, o);
    } catch (o) {
      throw (
        (ii(),
        he((i) => {
          i.addEventProcessor(
            (a) => (
              e.mechanism && (qt(a, void 0), ct(a, e.mechanism)),
              (a.extra = {
                ...a.extra,
                arguments: s,
              }),
              a
            ),
          ),
            Se(o);
        }),
        o)
      );
    }
  };
  try {
    for (const s in t)
      Object.prototype.hasOwnProperty.call(t, s) && (r[s] = t[s]);
  } catch {}
  Tn(r, t), w(t, '__sentry_wrapped__', r);
  try {
    Object.getOwnPropertyDescriptor(r, 'name').configurable &&
      Object.defineProperty(r, 'name', {
        get() {
          return t.name;
        },
      });
  } catch {}
  return r;
}
const ht = typeof __SENTRY_DEBUG__ > 'u' || __SENTRY_DEBUG__;
function Ee(t, e) {
  const n = be(t, e),
    r = {
      type: di(e),
      value: li(e),
    };
  return (
    n.length && (r.stacktrace = { frames: n }),
    r.type === void 0 &&
      r.value === '' &&
      (r.value = 'Unrecoverable error caught'),
    r
  );
}
function ai(t, e, n, r) {
  const s = S(),
    o = s && s.getOptions().normalizeDepth,
    i = gi(e),
    a = {
      __serialized__: On(e, o),
    };
  if (i)
    return {
      exception: {
        values: [Ee(t, i)],
      },
      extra: a,
    };
  const c = {
    exception: {
      values: [
        {
          type: Ot(e) ? e.constructor.name : r ? 'UnhandledRejection' : 'Error',
          value: _i(e, { isUnhandledRejection: r }),
        },
      ],
    },
    extra: a,
  };
  if (n) {
    const u = be(t, n);
    u.length && (c.exception.values[0].stacktrace = { frames: u });
  }
  return c;
}
function Ft(t, e) {
  return {
    exception: {
      values: [Ee(t, e)],
    },
  };
}
function be(t, e) {
  const n = e.stacktrace || e.stack || '',
    r = ui(e),
    s = fi(e);
  try {
    return t(n, r, s);
  } catch {}
  return [];
}
const ci = /Minified React error #\d+;/i;
function ui(t) {
  return t && ci.test(t.message) ? 1 : 0;
}
function fi(t) {
  return typeof t.framesToPop == 'number' ? t.framesToPop : 0;
}
function Zn(t) {
  return typeof WebAssembly < 'u' && typeof WebAssembly.Exception < 'u'
    ? t instanceof WebAssembly.Exception
    : !1;
}
function di(t) {
  const e = t && t.name;
  return !e && Zn(t)
    ? t.message && Array.isArray(t.message) && t.message.length == 2
      ? t.message[0]
      : 'WebAssembly.Exception'
    : e;
}
function li(t) {
  const e = t && t.message;
  return e
    ? e.error && typeof e.error.message == 'string'
      ? e.error.message
      : Zn(t) && Array.isArray(t.message) && t.message.length == 2
      ? t.message[1]
      : e
    : 'No error message';
}
function pi(t, e, n, r) {
  const s = (n && n.syntheticException) || void 0,
    o = Te(t, e, s, r);
  return (
    ct(o),
    (o.level = 'error'),
    n && n.event_id && (o.event_id = n.event_id),
    Y(o)
  );
}
function hi(t, e, n = 'info', r, s) {
  const o = (r && r.syntheticException) || void 0,
    i = ne(t, e, o, s);
  return (i.level = n), r && r.event_id && (i.event_id = r.event_id), Y(i);
}
function Te(t, e, n, r, s) {
  let o;
  if (gn(e) && e.error) return Ft(t, e.error);
  if (ve(e) || ar(e)) {
    const i = e;
    if ('stack' in e) o = Ft(t, e);
    else {
      const a = i.name || (ve(i) ? 'DOMError' : 'DOMException'),
        c = i.message ? `${a}: ${i.message}` : a;
      (o = ne(t, c, n, r)), qt(o, c);
    }
    return (
      'code' in i && (o.tags = { ...o.tags, 'DOMException.code': `${i.code}` }),
      o
    );
  }
  return ie(e)
    ? Ft(t, e)
    : X(e) || Ot(e)
    ? ((o = ai(t, e, n, s)),
      ct(o, {
        synthetic: !0,
      }),
      o)
    : ((o = ne(t, e, n, r)),
      qt(o, `${e}`),
      ct(o, {
        synthetic: !0,
      }),
      o);
}
function ne(t, e, n, r) {
  const s = {};
  if (r && n) {
    const o = be(t, n);
    o.length &&
      (s.exception = {
        values: [{ value: e, stacktrace: { frames: o } }],
      });
  }
  if (ae(e)) {
    const { __sentry_template_string__: o, __sentry_template_values__: i } = e;
    return (
      (s.logentry = {
        message: o,
        params: i,
      }),
      s
    );
  }
  return (s.message = e), s;
}
function _i(t, { isUnhandledRejection: e }) {
  const n = Nr(t),
    r = e ? 'promise rejection' : 'exception';
  return gn(t)
    ? `Event \`ErrorEvent\` captured as ${r} with message \`${t.message}\``
    : Ot(t)
    ? `Event \`${mi(t)}\` (type=${t.type}) captured as ${r}`
    : `Object captured as ${r} with keys: ${n}`;
}
function mi(t) {
  try {
    const e = Object.getPrototypeOf(t);
    return e ? e.constructor.name : void 0;
  } catch {}
}
function gi(t) {
  for (const e in t)
    if (Object.prototype.hasOwnProperty.call(t, e)) {
      const n = t[e];
      if (n instanceof Error) return n;
    }
}
function yi(t, { metadata: e, tunnel: n, dsn: r }) {
  const s = {
      event_id: t.event_id,
      sent_at: /* @__PURE__ */ new Date().toISOString(),
      ...(e &&
        e.sdk && {
          sdk: {
            name: e.sdk.name,
            version: e.sdk.version,
          },
        }),
      ...(!!n && !!r && { dsn: ft(r) }),
    },
    o = Si(t);
  return nt(s, [o]);
}
function Si(t) {
  return [
    {
      type: 'user_report',
    },
    t,
  ];
}
class Ei extends Ro {
  /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */
  constructor(e) {
    const n = {
        // We default this to true, as it is the safer scenario
        parentSpanIsAlwaysRootSpan: !0,
        ...e,
      },
      r = y.SENTRY_SDK_SOURCE || Hr();
    Po(n, 'browser', ['browser'], r),
      super(n),
      n.sendClientReports &&
        y.document &&
        y.document.addEventListener('visibilitychange', () => {
          y.document.visibilityState === 'hidden' && this._flushOutcomes();
        });
  }
  /**
   * @inheritDoc
   */
  eventFromException(e, n) {
    return pi(this._options.stackParser, e, n, this._options.attachStacktrace);
  }
  /**
   * @inheritDoc
   */
  eventFromMessage(e, n = 'info', r) {
    return hi(
      this._options.stackParser,
      e,
      n,
      r,
      this._options.attachStacktrace,
    );
  }
  /**
   * Sends user feedback to Sentry.
   *
   * @deprecated Use `captureFeedback` instead.
   */
  captureUserFeedback(e) {
    if (!this._isEnabled()) {
      ht && l.warn('SDK not enabled, will not capture user feedback.');
      return;
    }
    const n = yi(e, {
      metadata: this.getSdkMetadata(),
      dsn: this.getDsn(),
      tunnel: this.getOptions().tunnel,
    });
    this.sendEnvelope(n);
  }
  /**
   * @inheritDoc
   */
  _prepareEvent(e, n, r) {
    return (
      (e.platform = e.platform || 'javascript'), super._prepareEvent(e, n, r)
    );
  }
}
const bi = typeof __SENTRY_DEBUG__ > 'u' || __SENTRY_DEBUG__,
  E = g,
  Ti = 1e3;
let un, re, se;
function Ii(t) {
  const e = 'dom';
  q(e, t), V(e, vi);
}
function vi() {
  if (!E.document) return;
  const t = D.bind(null, 'dom'),
    e = fn(t, !0);
  E.document.addEventListener('click', e, !1),
    E.document.addEventListener('keypress', e, !1),
    ['EventTarget', 'Node'].forEach((n) => {
      const r = E[n] && E[n].prototype;
      !r ||
        !r.hasOwnProperty ||
        !r.hasOwnProperty('addEventListener') ||
        (v(r, 'addEventListener', function (s) {
          return function (o, i, a) {
            if (o === 'click' || o == 'keypress')
              try {
                const c = this,
                  u = (c.__sentry_instrumentation_handlers__ =
                    c.__sentry_instrumentation_handlers__ || {}),
                  f = (u[o] = u[o] || { refCount: 0 });
                if (!f.handler) {
                  const d = fn(t);
                  (f.handler = d), s.call(this, o, d, a);
                }
                f.refCount++;
              } catch {}
            return s.call(this, o, i, a);
          };
        }),
        v(r, 'removeEventListener', function (s) {
          return function (o, i, a) {
            if (o === 'click' || o == 'keypress')
              try {
                const c = this,
                  u = c.__sentry_instrumentation_handlers__ || {},
                  f = u[o];
                f &&
                  (f.refCount--,
                  f.refCount <= 0 &&
                    (s.call(this, o, f.handler, a),
                    (f.handler = void 0),
                    delete u[o]),
                  Object.keys(u).length === 0 &&
                    delete c.__sentry_instrumentation_handlers__);
              } catch {}
            return s.call(this, o, i, a);
          };
        }));
    });
}
function ki(t) {
  if (t.type !== re) return !1;
  try {
    if (!t.target || t.target._sentryId !== se) return !1;
  } catch {}
  return !0;
}
function Ni(t, e) {
  return t !== 'keypress'
    ? !1
    : !e || !e.tagName
    ? !0
    : !(
        e.tagName === 'INPUT' ||
        e.tagName === 'TEXTAREA' ||
        e.isContentEditable
      );
}
function fn(t, e = !1) {
  return (n) => {
    if (!n || n._sentryCaptured) return;
    const r = wi(n);
    if (Ni(n.type, r)) return;
    w(n, '_sentryCaptured', !0), r && !r._sentryId && w(r, '_sentryId', b());
    const s = n.type === 'keypress' ? 'input' : n.type;
    ki(n) ||
      (t({ event: n, name: s, global: e }),
      (re = n.type),
      (se = r ? r._sentryId : void 0)),
      clearTimeout(un),
      (un = E.setTimeout(() => {
        (se = void 0), (re = void 0);
      }, Ti));
  };
}
function wi(t) {
  try {
    return t.target;
  } catch {
    return null;
  }
}
let bt;
function Qn(t) {
  const e = 'history';
  q(e, t), V(e, Ri);
}
function Ri() {
  if (!hs()) return;
  const t = E.onpopstate;
  E.onpopstate = function (...n) {
    const r = E.location.href,
      s = bt;
    if (((bt = r), D('history', { from: s, to: r }), t))
      try {
        return t.apply(this, n);
      } catch {}
  };
  function e(n) {
    return function (...r) {
      const s = r.length > 2 ? r[2] : void 0;
      if (s) {
        const o = bt,
          i = String(s);
        (bt = i), D('history', { from: o, to: i });
      }
      return n.apply(this, r);
    };
  }
  v(E.history, 'pushState', e), v(E.history, 'replaceState', e);
}
const vt = {};
function Oi(t) {
  const e = vt[t];
  if (e) return e;
  let n = E[t];
  if (Wt(n)) return (vt[t] = n.bind(E));
  const r = E.document;
  if (r && typeof r.createElement == 'function')
    try {
      const s = r.createElement('iframe');
      (s.hidden = !0), r.head.appendChild(s);
      const o = s.contentWindow;
      o && o[t] && (n = o[t]), r.head.removeChild(s);
    } catch (s) {
      bi &&
        l.warn(
          `Could not create sandbox iframe for ${t} check, bailing to window.${t}: `,
          s,
        );
    }
  return n && (vt[t] = n.bind(E));
}
function dn(t) {
  vt[t] = void 0;
}
const ot = '__sentry_xhr_v3__';
function Di(t) {
  const e = 'xhr';
  q(e, t), V(e, Ai);
}
function Ai() {
  if (!E.XMLHttpRequest) return;
  const t = XMLHttpRequest.prototype;
  (t.open = new Proxy(t.open, {
    apply(e, n, r) {
      const s = N() * 1e3,
        o = C(r[0]) ? r[0].toUpperCase() : void 0,
        i = $i(r[1]);
      if (!o || !i) return e.apply(n, r);
      (n[ot] = {
        method: o,
        url: i,
        request_headers: {},
      }),
        o === 'POST' &&
          i.match(/sentry_key/) &&
          (n.__sentry_own_request__ = !0);
      const a = () => {
        const c = n[ot];
        if (c && n.readyState === 4) {
          try {
            c.status_code = n.status;
          } catch {}
          const u = {
            endTimestamp: N() * 1e3,
            startTimestamp: s,
            xhr: n,
          };
          D('xhr', u);
        }
      };
      return (
        'onreadystatechange' in n && typeof n.onreadystatechange == 'function'
          ? (n.onreadystatechange = new Proxy(n.onreadystatechange, {
              apply(c, u, f) {
                return a(), c.apply(u, f);
              },
            }))
          : n.addEventListener('readystatechange', a),
        (n.setRequestHeader = new Proxy(n.setRequestHeader, {
          apply(c, u, f) {
            const [d, p] = f,
              m = u[ot];
            return (
              m && C(d) && C(p) && (m.request_headers[d.toLowerCase()] = p),
              c.apply(u, f)
            );
          },
        })),
        e.apply(n, r)
      );
    },
  })),
    (t.send = new Proxy(t.send, {
      apply(e, n, r) {
        const s = n[ot];
        if (!s) return e.apply(n, r);
        r[0] !== void 0 && (s.body = r[0]);
        const o = {
          startTimestamp: N() * 1e3,
          xhr: n,
        };
        return D('xhr', o), e.apply(n, r);
      },
    }));
}
function $i(t) {
  if (C(t)) return t;
  try {
    return t.toString();
  } catch {}
}
function Ci(t, e = Oi('fetch')) {
  let n = 0,
    r = 0;
  function s(o) {
    const i = o.body.length;
    (n += i), r++;
    const a = {
      body: o.body,
      method: 'POST',
      referrerPolicy: 'origin',
      headers: t.headers,
      // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
      // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
      // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
      // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
      // Gotchas:
      // - `keepalive` isn't supported by Firefox
      // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
      //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
      //   We will therefore only activate the flag when we're below that limit.
      // There is also a limit of requests that can be open at the same time, so we also limit this to 15
      // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
      keepalive: n <= 6e4 && r < 15,
      ...t.fetchOptions,
    };
    if (!e) return dn('fetch'), Nt('No fetch implementation available');
    try {
      return e(t.url, a).then(
        (c) => (
          (n -= i),
          r--,
          {
            statusCode: c.status,
            headers: {
              'x-sentry-rate-limits': c.headers.get('X-Sentry-Rate-Limits'),
              'retry-after': c.headers.get('Retry-After'),
            },
          }
        ),
      );
    } catch (c) {
      return dn('fetch'), (n -= i), r--, Nt(c);
    }
  }
  return xo(t, s);
}
const xi = 30,
  Pi = 50;
function oe(t, e, n, r) {
  const s = {
    filename: t,
    function: e === '<anonymous>' ? W : e,
    in_app: !0,
    // All browser frames are considered in_app
  };
  return n !== void 0 && (s.lineno = n), r !== void 0 && (s.colno = r), s;
}
const Mi = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i,
  Li =
    /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i,
  Fi = /\((\S*)(?::(\d+))(?::(\d+))\)/,
  Ui = (t) => {
    const e = Mi.exec(t);
    if (e) {
      const [, r, s, o] = e;
      return oe(r, W, +s, +o);
    }
    const n = Li.exec(t);
    if (n) {
      if (n[2] && n[2].indexOf('eval') === 0) {
        const i = Fi.exec(n[2]);
        i && ((n[2] = i[1]), (n[3] = i[2]), (n[4] = i[3]));
      }
      const [s, o] = tr(n[1] || W, n[2]);
      return oe(o, s, n[3] ? +n[3] : void 0, n[4] ? +n[4] : void 0);
    }
  },
  ji = [xi, Ui],
  Hi =
    /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i,
  Bi = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i,
  Gi = (t) => {
    const e = Hi.exec(t);
    if (e) {
      if (e[3] && e[3].indexOf(' > eval') > -1) {
        const o = Bi.exec(e[3]);
        o &&
          ((e[1] = e[1] || 'eval'), (e[3] = o[1]), (e[4] = o[2]), (e[5] = ''));
      }
      let r = e[3],
        s = e[1] || W;
      return (
        ([s, r] = tr(s, r)),
        oe(r, s, e[4] ? +e[4] : void 0, e[5] ? +e[5] : void 0)
      );
    }
  },
  Wi = [Pi, Gi],
  Yi = [ji, Wi],
  qi = kn(...Yi),
  tr = (t, e) => {
    const n = t.indexOf('safari-extension') !== -1,
      r = t.indexOf('safari-web-extension') !== -1;
    return n || r
      ? [
          t.indexOf('@') !== -1 ? t.split('@')[0] : W,
          n ? `safari-extension:${e}` : `safari-web-extension:${e}`,
        ]
      : [t, e];
  },
  Tt = 1024,
  Vi = 'Breadcrumbs',
  Ki = (t = {}) => {
    const e = {
      console: !0,
      dom: !0,
      fetch: !0,
      history: !0,
      sentry: !0,
      xhr: !0,
      ...t,
    };
    return {
      name: Vi,
      setup(n) {
        e.console && Dr(Ji(n)),
          e.dom && Ii(Xi(n, e.dom)),
          e.xhr && Di(Zi(n)),
          e.fetch && xr(Qi(n)),
          e.history && Qn(ta(n)),
          e.sentry && n.on('beforeSendEvent', zi(n));
      },
    };
  },
  er = Ki;
function zi(t) {
  return function (n) {
    S() === t &&
      H(
        {
          category: `sentry.${
            n.type === 'transaction' ? 'transaction' : 'event'
          }`,
          event_id: n.event_id,
          level: n.level,
          message: M(n),
        },
        {
          event: n,
        },
      );
  };
}
function Xi(t, e) {
  return function (r) {
    if (S() !== t) return;
    let s,
      o,
      i = typeof e == 'object' ? e.serializeAttribute : void 0,
      a =
        typeof e == 'object' && typeof e.maxStringLength == 'number'
          ? e.maxStringLength
          : void 0;
    a &&
      a > Tt &&
      (ht &&
        l.warn(
          `\`dom.maxStringLength\` cannot exceed ${Tt}, but a value of ${a} was configured. Sentry will use ${Tt} instead.`,
        ),
      (a = Tt)),
      typeof i == 'string' && (i = [i]);
    try {
      const u = r.event,
        f = ea(u) ? u.target : u;
      (s = En(f, { keyAttrs: i, maxStringLength: a })), (o = gr(f));
    } catch {
      s = '<unknown>';
    }
    if (s.length === 0) return;
    const c = {
      category: `ui.${r.name}`,
      message: s,
    };
    o && (c.data = { 'ui.component_name': o }),
      H(c, {
        event: r.event,
        name: r.name,
        global: r.global,
      });
  };
}
function Ji(t) {
  return function (n) {
    if (S() !== t) return;
    const r = {
      category: 'console',
      data: {
        arguments: n.args,
        logger: 'console',
      },
      level: zr(n.level),
      message: ke(n.args, ' '),
    };
    if (n.level === 'assert')
      if (n.args[0] === !1)
        (r.message = `Assertion failed: ${
          ke(n.args.slice(1), ' ') || 'console.assert'
        }`),
          (r.data.arguments = n.args.slice(1));
      else return;
    H(r, {
      input: n.args,
      level: n.level,
    });
  };
}
function Zi(t) {
  return function (n) {
    if (S() !== t) return;
    const { startTimestamp: r, endTimestamp: s } = n,
      o = n.xhr[ot];
    if (!r || !s || !o) return;
    const { method: i, url: a, status_code: c, body: u } = o,
      f = {
        method: i,
        url: a,
        status_code: c,
      },
      d = {
        xhr: n.xhr,
        input: u,
        startTimestamp: r,
        endTimestamp: s,
      },
      p = Sn(c);
    H(
      {
        category: 'xhr',
        data: f,
        type: 'http',
        level: p,
      },
      d,
    );
  };
}
function Qi(t) {
  return function (n) {
    if (S() !== t) return;
    const { startTimestamp: r, endTimestamp: s } = n;
    if (
      s &&
      !(n.fetchData.url.match(/sentry_key/) && n.fetchData.method === 'POST')
    )
      if (n.error) {
        const o = n.fetchData,
          i = {
            data: n.error,
            input: n.args,
            startTimestamp: r,
            endTimestamp: s,
          };
        H(
          {
            category: 'fetch',
            data: o,
            level: 'error',
            type: 'http',
          },
          i,
        );
      } else {
        const o = n.response,
          i = {
            ...n.fetchData,
            status_code: o && o.status,
          },
          a = {
            input: n.args,
            response: o,
            startTimestamp: r,
            endTimestamp: s,
          },
          c = Sn(i.status_code);
        H(
          {
            category: 'fetch',
            data: i,
            type: 'http',
            level: c,
          },
          a,
        );
      }
  };
}
function ta(t) {
  return function (n) {
    if (S() !== t) return;
    let r = n.from,
      s = n.to;
    const o = Lt(y.location.href);
    let i = r ? Lt(r) : void 0;
    const a = Lt(s);
    (!i || !i.path) && (i = o),
      o.protocol === a.protocol && o.host === a.host && (s = a.relative),
      o.protocol === i.protocol && o.host === i.host && (r = i.relative),
      H({
        category: 'navigation',
        data: {
          from: r,
          to: s,
        },
      });
  };
}
function ea(t) {
  return !!t && !!t.target;
}
const na = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'BroadcastChannel',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'SharedWorker',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload',
  ],
  ra = 'BrowserApiErrors',
  sa = (t = {}) => {
    const e = {
      XMLHttpRequest: !0,
      eventTarget: !0,
      requestAnimationFrame: !0,
      setInterval: !0,
      setTimeout: !0,
      ...t,
    };
    return {
      name: ra,
      // TODO: This currently only works for the first client this is setup
      // We may want to adjust this to check for client etc.
      setupOnce() {
        e.setTimeout && v(y, 'setTimeout', ln),
          e.setInterval && v(y, 'setInterval', ln),
          e.requestAnimationFrame && v(y, 'requestAnimationFrame', ia),
          e.XMLHttpRequest &&
            'XMLHttpRequest' in y &&
            v(XMLHttpRequest.prototype, 'send', aa);
        const n = e.eventTarget;
        n && (Array.isArray(n) ? n : na).forEach(ca);
      },
    };
  },
  oa = sa;
function ln(t) {
  return function (...e) {
    const n = e[0];
    return (
      (e[0] = Q(n, {
        mechanism: {
          data: { function: U(t) },
          handled: !1,
          type: 'instrument',
        },
      })),
      t.apply(this, e)
    );
  };
}
function ia(t) {
  return function (e) {
    return t.apply(this, [
      Q(e, {
        mechanism: {
          data: {
            function: 'requestAnimationFrame',
            handler: U(t),
          },
          handled: !1,
          type: 'instrument',
        },
      }),
    ]);
  };
}
function aa(t) {
  return function (...e) {
    const n = this;
    return (
      ['onload', 'onerror', 'onprogress', 'onreadystatechange'].forEach((s) => {
        s in n &&
          typeof n[s] == 'function' &&
          v(n, s, function (o) {
            const i = {
                mechanism: {
                  data: {
                    function: s,
                    handler: U(o),
                  },
                  handled: !1,
                  type: 'instrument',
                },
              },
              a = fe(o);
            return a && (i.mechanism.data.handler = U(a)), Q(o, i);
          });
      }),
      t.apply(this, e)
    );
  };
}
function ca(t) {
  const e = y,
    n = e[t] && e[t].prototype;
  !n ||
    !n.hasOwnProperty ||
    !n.hasOwnProperty('addEventListener') ||
    (v(n, 'addEventListener', function (r) {
      return function (s, o, i) {
        try {
          typeof o.handleEvent == 'function' &&
            (o.handleEvent = Q(o.handleEvent, {
              mechanism: {
                data: {
                  function: 'handleEvent',
                  handler: U(o),
                  target: t,
                },
                handled: !1,
                type: 'instrument',
              },
            }));
        } catch {}
        return r.apply(this, [
          s,
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          Q(o, {
            mechanism: {
              data: {
                function: 'addEventListener',
                handler: U(o),
                target: t,
              },
              handled: !1,
              type: 'instrument',
            },
          }),
          i,
        ]);
      };
    }),
    v(n, 'removeEventListener', function (r) {
      return function (s, o, i) {
        const a = o;
        try {
          const c = a && a.__sentry_wrapped__;
          c && r.call(this, s, c, i);
        } catch {}
        return r.call(this, s, a, i);
      };
    }));
}
const ua = 'GlobalHandlers',
  fa = (t = {}) => {
    const e = {
      onerror: !0,
      onunhandledrejection: !0,
      ...t,
    };
    return {
      name: ua,
      setupOnce() {
        Error.stackTraceLimit = 50;
      },
      setup(n) {
        e.onerror && (la(n), pn('onerror')),
          e.onunhandledrejection && (pa(n), pn('onunhandledrejection'));
      },
    };
  },
  da = fa;
function la(t) {
  Lr((e) => {
    const { stackParser: n, attachStacktrace: r } = nr();
    if (S() !== t || Jn()) return;
    const { msg: s, url: o, line: i, column: a, error: c } = e,
      u = ma(Te(n, c || s, void 0, r, !1), o, i, a);
    (u.level = 'error'),
      Gn(u, {
        originalException: c,
        mechanism: {
          handled: !1,
          type: 'onerror',
        },
      });
  });
}
function pa(t) {
  Ur((e) => {
    const { stackParser: n, attachStacktrace: r } = nr();
    if (S() !== t || Jn()) return;
    const s = ha(e),
      o = ce(s) ? _a(s) : Te(n, s, void 0, r, !0);
    (o.level = 'error'),
      Gn(o, {
        originalException: s,
        mechanism: {
          handled: !1,
          type: 'onunhandledrejection',
        },
      });
  });
}
function ha(t) {
  if (ce(t)) return t;
  try {
    if ('reason' in t) return t.reason;
    if ('detail' in t && 'reason' in t.detail) return t.detail.reason;
  } catch {}
  return t;
}
function _a(t) {
  return {
    exception: {
      values: [
        {
          type: 'UnhandledRejection',
          // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
          value: `Non-Error promise rejection captured with value: ${String(
            t,
          )}`,
        },
      ],
    },
  };
}
function ma(t, e, n, r) {
  const s = (t.exception = t.exception || {}),
    o = (s.values = s.values || []),
    i = (o[0] = o[0] || {}),
    a = (i.stacktrace = i.stacktrace || {}),
    c = (a.frames = a.frames || []),
    u = isNaN(parseInt(r, 10)) ? void 0 : r,
    f = isNaN(parseInt(n, 10)) ? void 0 : n,
    d = C(e) && e.length > 0 ? e : mr();
  return (
    c.length === 0 &&
      c.push({
        colno: u,
        filename: d,
        function: W,
        in_app: !0,
        lineno: f,
      }),
    t
  );
}
function pn(t) {
  ht && l.log(`Global Handler attached: ${t}`);
}
function nr() {
  const t = S();
  return (
    (t && t.getOptions()) || {
      stackParser: () => [],
      attachStacktrace: !1,
    }
  );
}
const ga = () => ({
    name: 'HttpContext',
    preprocessEvent(t) {
      if (!y.navigator && !y.location && !y.document) return;
      const e = (t.request && t.request.url) || (y.location && y.location.href),
        { referrer: n } = y.document || {},
        { userAgent: r } = y.navigator || {},
        s = {
          ...(t.request && t.request.headers),
          ...(n && { Referer: n }),
          ...(r && { 'User-Agent': r }),
        },
        o = { ...t.request, ...(e && { url: e }), headers: s };
      t.request = o;
    },
  }),
  ya = 'cause',
  Sa = 5,
  Ea = 'LinkedErrors',
  ba = (t = {}) => {
    const e = t.limit || Sa,
      n = t.key || ya;
    return {
      name: Ea,
      preprocessEvent(r, s, o) {
        const i = o.getOptions();
        lr(
          // This differs from the LinkedErrors integration in core by using a different exceptionFromError function
          Ee,
          i.stackParser,
          i.maxValueLength,
          n,
          e,
          r,
          s,
        );
      },
    };
  },
  Ta = ba;
function rr(t) {
  return [Go(), Uo(), oa(), er(), da(), Ta(), ni(), ga()];
}
function Ia(t = {}) {
  const e = {
    defaultIntegrations: rr(),
    release:
      typeof __SENTRY_RELEASE__ == 'string'
        ? __SENTRY_RELEASE__
        : y.SENTRY_RELEASE && y.SENTRY_RELEASE.id
        ? y.SENTRY_RELEASE.id
        : void 0,
    autoSessionTracking: !0,
    sendClientReports: !0,
  };
  return (
    t.defaultIntegrations == null && delete t.defaultIntegrations,
    { ...e, ...t }
  );
}
function va() {
  const t = typeof y.window < 'u' && y;
  if (!t) return !1;
  const e = t.chrome ? 'chrome' : 'browser',
    n = t[e],
    r = n && n.runtime && n.runtime.id,
    s = (y.location && y.location.href) || '',
    o = [
      'chrome-extension:',
      'moz-extension:',
      'ms-browser-extension:',
      'safari-web-extension:',
    ],
    i = !!r && y === y.top && o.some((c) => s.startsWith(`${c}//`)),
    a = typeof t.nw < 'u';
  return !!r && !i && !a;
}
function ka(t = {}) {
  const e = Ia(t);
  if (!e.skipBrowserExtensionCheck && va()) {
    B(() => {
      console.error(
        '[Sentry] You cannot run Sentry this way in a browser extension, check: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/',
      );
    });
    return;
  }
  ht &&
    (Nn() ||
      l.warn(
        'No Fetch API detected. The Sentry SDK requires a Fetch API compatible environment to send events. Please add a Fetch API polyfill.',
      ));
  const n = {
      ...e,
      stackParser: Rr(e.stackParser || qi),
      integrations: No(e),
      transport: e.transport || Ci,
    },
    r = Ao(Ei, n);
  return e.autoSessionTracking && Na(), r;
}
function Na() {
  if (typeof y.document > 'u') {
    ht &&
      l.warn(
        'Session tracking in non-browser environment with @sentry/browser is not supported.',
      );
    return;
  }
  Qe({ ignoreDuration: !0 }),
    tn(),
    Qn(({ from: t, to: e }) => {
      t !== void 0 && t !== e && (Qe({ ignoreDuration: !0 }), tn());
    });
}
const sr = ['activate', 'mount', 'update'],
  or = typeof __SENTRY_DEBUG__ > 'u' || __SENTRY_DEBUG__,
  wa = /(?:^|[-_])(\w)/g,
  Ra = (t) => t.replace(wa, (e) => e.toUpperCase()).replace(/[-_]/g, ''),
  Oa = '<Root>',
  Ut = '<Anonymous>',
  Da = (t, e) => t.repeat(e),
  at = (t, e) => {
    if (!t) return Ut;
    if (t.$root === t) return Oa;
    if (!t.$options) return Ut;
    const n = t.$options;
    let r = n.name || n._componentTag || n.__name;
    const s = n.__file;
    if (!r && s) {
      const o = s.match(/([^/\\]+)\.vue$/);
      o && (r = o[1]);
    }
    return (r ? `<${Ra(r)}>` : Ut) + (s && e !== !1 ? ` at ${s}` : '');
  },
  Aa = (t) => {
    if (t && (t._isVue || t.__isVue) && t.$parent) {
      const e = [];
      let n = 0;
      for (; t; ) {
        if (e.length > 0) {
          const s = e[e.length - 1];
          if (s.constructor === t.constructor) {
            n++, (t = t.$parent);
            continue;
          } else n > 0 && ((e[e.length - 1] = [s, n]), (n = 0));
        }
        e.push(t), (t = t.$parent);
      }
      return `

found in

${e.map(
  (s, o) =>
    `${
      (o === 0 ? '---> ' : Da(' ', 5 + o * 2)) +
      (Array.isArray(s) ? `${at(s[0])}... (${s[1]} recursive calls)` : at(s))
    }`,
).join(`
`)}`;
    }
    return `

(found in ${at(t)})`;
  },
  $a = (t, e) => {
    const { errorHandler: n, warnHandler: r, silent: s } = t.config;
    t.config.errorHandler = (o, i, a) => {
      const c = at(i, !1),
        u = i ? Aa(i) : '',
        f = {
          componentName: c,
          lifecycleHook: a,
          trace: u,
        };
      if (
        (e.attachProps &&
          i &&
          (i.$options && i.$options.propsData
            ? (f.propsData = i.$options.propsData)
            : i.$props && (f.propsData = i.$props)),
        setTimeout(() => {
          Se(o, {
            captureContext: { contexts: { vue: f } },
            mechanism: { handled: !1 },
          });
        }),
        typeof n == 'function' && t.config.errorHandler && n.call(t, o, i, a),
        e.logErrors)
      ) {
        const d = typeof console < 'u',
          p = `Error in ${a}: "${o && o.toString()}"`;
        r
          ? r.call(null, p, i, u)
          : d &&
            !s &&
            B(() => {
              console.error(`[Vue warn]: ${p}${u}`);
            });
      }
    };
  },
  hn = 'ui.vue',
  Ca = {
    activate: ['activated', 'deactivated'],
    create: ['beforeCreate', 'created'],
    // Vue 3
    unmount: ['beforeUnmount', 'unmounted'],
    // Vue 2
    destroy: ['beforeDestroy', 'destroyed'],
    mount: ['beforeMount', 'mounted'],
    update: ['beforeUpdate', 'updated'],
  };
function xa(t, e, n) {
  t.$_sentryRootSpanTimer && clearTimeout(t.$_sentryRootSpanTimer),
    (t.$_sentryRootSpanTimer = setTimeout(() => {
      t.$root &&
        t.$root.$_sentryRootSpan &&
        (t.$root.$_sentryRootSpan.end(e), (t.$root.$_sentryRootSpan = void 0));
    }, n));
}
function Pa(t, e) {
  function n(s) {
    return s.replace(/^<([^\s]*)>(?: at [^\s]*)?$/, '$1');
  }
  return t.some((s) => n(e) === n(s));
}
const Ma = (t) => {
    const e = (t.hooks || [])
        .concat(sr)
        .filter((r, s, o) => o.indexOf(r) === s),
      n = {};
    for (const r of e) {
      const s = Ca[r];
      if (!s) {
        or && l.warn(`Unknown hook: ${r}`);
        continue;
      }
      for (const o of s)
        n[o] = function () {
          const i = this.$root === this;
          i &&
            Ge() &&
            (this.$_sentryRootSpan =
              this.$_sentryRootSpan ||
              Xe({
                name: 'Application Render',
                op: `${hn}.render`,
                attributes: {
                  [ut]: 'auto.ui.vue',
                },
              }));
          const a = at(this, !1),
            c = Array.isArray(t.trackComponents)
              ? Pa(t.trackComponents, a)
              : t.trackComponents;
          if (!(!i && !c))
            if (((this.$_sentrySpans = this.$_sentrySpans || {}), o == s[0])) {
              if ((this.$root && this.$root.$_sentryRootSpan) || Ge()) {
                const f = this.$_sentrySpans[r];
                f && f.end(),
                  (this.$_sentrySpans[r] = Xe({
                    name: `Vue ${a}`,
                    op: `${hn}.${r}`,
                    attributes: {
                      [ut]: 'auto.ui.vue',
                    },
                    // UI spans should only be created if there is an active root span (transaction)
                    onlyIfParent: !0,
                  }));
              }
            } else {
              const u = this.$_sentrySpans[r];
              if (!u) return;
              u.end(), xa(this, N(), t.timeout);
            }
        };
    }
    return n;
  },
  La = g,
  Fa = {
    Vue: La.Vue,
    attachProps: !0,
    logErrors: !0,
    attachErrorHandler: !0,
    hooks: sr,
    timeout: 2e3,
    trackComponents: !1,
  },
  Ua = 'Vue',
  ja = (t = {}) => ({
    name: Ua,
    setup(e) {
      Ba(e, t);
    },
  }),
  Ha = ja;
function Ba(t, e) {
  const n = { ...Fa, ...t.getOptions(), ...e };
  if (!n.Vue && !n.app) {
    B(() => {
      console.warn(
        '[@sentry/vue]: Misconfigured SDK. Vue specific errors will not be captured.\nUpdate your `Sentry.init` call with an appropriate config option:\n`app` (Application Instance - Vue 3) or `Vue` (Vue Constructor - Vue 2).',
      );
    });
    return;
  }
  n.app ? de(n.app).forEach((s) => _n(s, n)) : n.Vue && _n(n.Vue, n);
}
const _n = (t, e) => {
  if (or) {
    const n = t;
    (n._instance && n._instance.isMounted) === !0 &&
      B(() => {
        console.warn(
          '[@sentry/vue]: Misconfigured SDK. Vue app is already mounted. Make sure to call `app.mount()` after `Sentry.init()`.',
        );
      });
  }
  e.attachErrorHandler && $a(t, e),
    Ct(e) &&
      t.mixin(
        Ma({
          ...e,
          ...e.tracingOptions,
        }),
      );
};
function Ga(t = {}) {
  const e = {
    _metadata: {
      sdk: {
        name: 'sentry.javascript.vue',
        packages: [
          {
            name: 'npm:@sentry/vue',
            version: x,
          },
        ],
        version: x,
      },
    },
    defaultIntegrations: [...rr(), Ha()],
    ...t,
  };
  return ka(e);
}
const ir = (t) =>
    t
      .replace(/%c/g, '')
      .replace(/color:\s*#[\dA-Fa-f]{3,6}|color:\s*inherit/g, ''),
  Wa = (t) =>
    !(t != null && t.arguments) || !Array.isArray(t.arguments)
      ? t
      : {
          ...t,
          arguments: t.arguments
            .map((e) => (typeof e == 'string' ? ir(e) : e))
            .filter(Boolean),
        },
  Ya = () => ({
    name: 'StripColorsIntegration',
    setupOnce() {
      So(
        (t) => (
          t.breadcrumbs &&
            (t.breadcrumbs = t.breadcrumbs.map((e) => ({
              ...e,
              message: e.message ? ir(e.message) : e.message,
              data: Wa(e.data),
            }))),
          t
        ),
      );
    },
  });
class qa {
  constructor(e) {
    Ga(e);
  }
  // Sentry has special treatment in the UI for users,
  // so try and filter out a special 'user' label which
  // we'll use as a unique user in Sentry.
  // All other labels can go to Sentry as tags.
  // user: https://docs.sentry.io/platforms/javascript/enriching-events/identify-user/
  // tags: https://docs.sentry.io/platforms/javascript/enriching-events/tags/
  parseUser(e) {
    let n;
    const r = {};
    for (const s in e) {
      const o = e[s];
      if (s === 'user') {
        n = { id: o };
        continue;
      }
      r[s] = o;
    }
    return { user: n, otherLabels: r };
  }
  // Make sure to track when labels are set,
  // because sentry needs to consistently track this information
  // These two global sentry functions operate on the sentry isolation scope,
  // which in the browser just acts as a 'global' scope.
  // scopes: https://docs.sentry.io/platforms/javascript/enriching-events/scopes/
  onLabelsSet(e) {
    const { user: n, otherLabels: r } = this.parseUser(e);
    yo(n ?? null), go(r);
  }
  reportError(e, n) {
    const { user: r, otherLabels: s } = this.parseUser(n);
    Se(e, { user: r, tags: s });
  }
  addBreadcrumb(e, n) {
    H(e, n);
  }
}
function Va(t) {
  const e = !!t.env.DEV,
    n = t.vueApp,
    r = t.env.SENTRY_INGEST_URL,
    s = Number(t.env.SENTRY_TRACES_SAMPLE_RATE),
    o = t.env.APP_NAME,
    i = t.env.APP_VERSION,
    a = `${o}@${i}`,
    c = t.env.ENV ?? 'production';
  return {
    errorProvider: new qa({
      dsn: r,
      app: n,
      release: a,
      environment: c,
      debug: e,
      tracesSampleRate: s,
      logErrors: !0,
      integrations: (f) => [
        ...f.map((d) =>
          d.name === 'Breadcrumbs'
            ? // Don't automatically add the console integration
              // To support proper integration with logger we will
              // write breadcrumbs manually
              er({ console: !1 })
            : d,
        ),
        Ya(),
      ],
    }),
  };
}
export { qa as SentryPlugin, Va as hostSentry };
